// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:33:35.512Z
// Property: Bend at New Road (ID: 6767906449167035)
// Collections: 35 amenities, 9 floorplans (live), 25 photos, 59 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449167035",
  "property_external_id": "1224222",
  "property_zillow_url": "https://www.zillow.com/apartments/waco-tx/bend-at-new-road/CgtNfB/",
  "property_apartments_url": "https://www.apartments.com/bend-at-new-road-waco-tx/3grv55d/",
  "property_google_business_url": "https://www.google.com/maps/place/Bend+at+New+Road/data=!4m2!3m1!1s0x0:0xa6a2bd7ec19de13e?sa=X&ved=2ahUKEwj1r8OYgIOTAxX9hIkEHeLzBWwQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "bend-at-new-road",
  "property_name": "Bend at New Road",
  "property_website_url": "https://www.caseusa.com/apartments/tx/waco/bend-at-new-road/",
  "property_domain": null,
  "property_address": "3000 S. New Road",
  "property_full_address": "3000 S. New Road, Waco, TX, 76706",
  "property_address_1": "3000 S. New Road",
  "property_address_2": null,
  "property_address_city": "Waco",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "76706",
  "property_address_country": "US",
  "property_address_county": "McLennan County",
  "property_neighborhood_address": "Alta Vista",
  "property_address_latitude": "31.5084",
  "property_address_longitude": "-97.1374",
  "property_email": "thebend@caseusa.com",
  "property_phone": "(254) 632-5037",
  "property_call_tracking_phone": "833-776-3536",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Bend at New Road, where luxury meets comfort in Waco, TX! Choose from spacious one or two-bedroom floor plans featuring modern designs and upscale amenities. Enjoy relaxing days by the resort-worthy pool, energizing workouts in our 24-hour fitness center, and playful moments at our onsite dog park. Your perfect home awaits! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Bend at New Road, where modern living meets comfort in the heart of Waco, TX! Our thoughtfully designed apartment community offers a variety of floor plans, featuring spacious one and two-bedroom layouts that cater to your lifestyle needs. Each apartment boasts soaring 9-foot ceilings, plush wall-to-wall carpeting, and stylish finishes including a white subway tile backsplash and dove gray or espresso brown cabinetry.\n\nAt Bend at New Road, we believe that home is where the heart is. Our community amenities enhance your living experience with a resort-worthy swimming pool and sundeck, perfect for relaxation. Unwind in the Grill & Chill Area or take your furry friends to our onsite dog park and enjoy our lush courtyards equipped with pet stations. For your convenience, we offer 24-hour emergency maintenance, gated access, and secure package receiving.\n\nStay active in our on-trend fitness center or social in our relaxing clubhouse featuring billiards and shuffleboard. Our Internet Cafe serves complimentary gourmet coffee and tea, ensuring you’re fueled throughout your day with super-fast internet powered by AT&T. \n\nWith features like private patios or balconies, side-by-side refrigerators, and stylish window coverings, your new home at Bend at New Road is ready to meet your needs. Choose from our modern construction options, including townhome-style living, and enjoy the flexibility of electronic payments and various payment options.\n\nDon’t miss out—find your new home today! Browse our availability or schedule a tour to visit our welcoming community at Bend at New Road in Waco, TX!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb4f-de71-775c-baa4-ce2088b93758.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of the apartment complex's clubhouse and residential buildings under a blue sky.",
    "public_id": "019cfb4f-de71-775c-baa4-ce2088b93758",
    "storage_key": "property/6767906449167035/019cfb4f-de71-775c-baa4-ce2088b93758.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "252",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": "27",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.01587301587301",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "225-275",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "breed restrictions apply",
  "property_pet_policy_description": "80lbs max",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://bendatnewroadapartmentswaco.securecafe.com/onlineleasing/bend-at-new-road/floorplans.aspx",
  "property_resident_portal_url": "https://bendatnewroadapartmentswaco.securecafe.com/residentservices/bend-at-new-road/userlogin.aspx",
  "property_apply_now_url": "https://bendatnewroadapartmentswaco.securecafe.com/onlineleasing/bend-at-new-road/register.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-3ad2-71f2-9a27-63728aead156.webp",
  "property_primary_logo_media": {
    "alt_text": "Bend logo with @ symbol.",
    "public_id": "019cfb50-3ad2-71f2-9a27-63728aead156",
    "storage_key": "property/6767906449167035/019cfb50-3ad2-71f2-9a27-63728aead156.webp",
    "width": 350,
    "height": 130
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb51-2deb-72aa-891c-47ff625d0581.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Bend @ New Road Apartments logo",
    "public_id": "019cfb51-2deb-72aa-891c-47ff625d0581",
    "storage_key": "property/6767906449167035/019cfb51-2deb-72aa-891c-47ff625d0581.webp",
    "width": 350,
    "height": 130
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb51-3ada-76e7-9b15-1dd11d3ab3cd.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Bend at New Road logo",
    "public_id": "019cfb51-3ada-76e7-9b15-1dd11d3ab3cd",
    "storage_key": "property/6767906449167035/019cfb51-3ada-76e7-9b15-1dd11d3ab3cd.webp",
    "width": 350,
    "height": 130
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#818688",
  "property_secondary_color": "#13afbd",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#cac4b8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1050",
  "property_sqft_min": "789",
  "property_sqft_max": "1050",
  "property_price_range": "1309 - 1539",
  "property_price_min": "1309",
  "property_price_max": "1539",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/BendatNewRoad/posts/at-bend-at-new-road-youll-find-roomy-welcoming-homes-paired-with-features-that-m/1206497971491981/",
  "property_instagram_url": "https://www.instagram.com/p/C7XnGCstjjR/?hl=de",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJwZamy5CBT4YRPuGdwX69oqY",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Parks&find_loc=Elm+Mott%2C+TX",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Bend at New Road",
  "property_home_romance_title": "Embrace Your Dream Lifestyle in Our Charming Apartment Community",
  "property_home_amenities_blurb": "Welcome to Bend at New Road in Waco, TX, where luxury meets comfort. Choose from spacious one- and two-bedroom floor plans, each boasting modern amenities like soaring ceilings, resort-style pool, and a pet-friendly atmosphere. Unwind at our grill area or enjoy complimentary gourmet coffee in the internet café. Your ideal lifestyle awaits!",
  "property_home_floorplans_blurb": "At Bend at New Road in Waco, TX, your ideal living space awaits! Choose from a variety of thoughtfully designed floor plans that blend comfort and style. Each apartment home invites you to create a lifestyle that's entirely your own. Browse our selections today and envision your next chapter!",
  "property_home_gallery_blurb": "At Bend at New Road in Waco, TX, experience modern living with distinctive floor plans and a vibrant community vibe. Enjoy lush courtyards, a resort-style swimming pool, and a 24-hour fitness center all while being pet-friendly. Picture yourself relaxing by the grill or indulging in complimentary coffee at our Internet café!",
  "property_home_neighborhood_blurb": "Nestled in vibrant Waco, Bend at New Road offers spacious one and two-bedroom apartments just moments from Baylor University, McLennan Community College, and the captivating Dr Pepper Museum. With nearby parks, the rich history of the Texas Ranger Hall of Fame, and engaging attractions, your ideal home awaits.",
  "property_home_reviews_blurb": "At Bend at New Road in Waco, TX, residents rave about the welcoming atmosphere and spacious layouts, exclaiming, “It truly feels like home!” Experience a vibrant community where comfort meets convenience. Check out what our residents say about life here; their stories reflect the heart of our living experience!",
  "property_neighborhood_blurb": "At Bend at New Road in Waco, TX, vibrant living meets the heart of community. Nestled near Baylor University and the serene Cameron Park, you’ll find enriching spots like the Dr Pepper Museum and the Mayborn Museum Complex. Uncover the charm of local culture, educational gems, and more right outside your door!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Bend at New Road in Waco, TX, every detail is crafted for comfort and convenience. Enjoy pet-friendly living with an onsite dog park, unwind at our resort-style pool, or energize in the 24-hour fitness center. With spacious layouts and modern finishes, your perfect home awaits—come see it for yourself!",
  "property_applynow_blurb": "Elevate your lifestyle at Bend at New Road in Waco, TX, where modern comfort meets timeless elegance. Enjoy chef-inspired kitchens, a resort-style pool, and a pet-friendly dog park—all designed with you in mind. Embrace spacious layouts and engaging amenities. Your new home awaits—lease online today!",
  "property_contactus_blurb": "At Bend at New Road in Waco, TX, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Whether you seek cozy solitude or shared comfort, we have the perfect space for you. Have questions? Our leasing team is here to help—reach out today for more information!",
  "property_faqs_blurb": "At Bend at New Road in Waco, TX, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Curious about our community? Find clarity and insights by visiting our FAQs page, where all your questions are answered with a friendly touch. Your new home awaits!",
  "property_floorplans_blurb": "At Bend at New Road in Waco, TX, modern living takes shape with versatile one and two-bedroom floor plans tailored to your lifestyle. Spacious layouts and stylish designs await—unlock the door to your new home. Browse our available apartment homes and imagine the possibilities today!",
  "property_gallery_blurb": "At Bend at New Road in Waco, TX, your dream lifestyle awaits. Imagine lounging by the resort-worthy pool, enjoying gourmet coffee at our internet café, or playing billiards in the stylish clubhouse. With spacious one and two-bedroom apartments and upscale amenities, picture yourself living here in comfort and style!",
  "property_interactivemap_blurb": "At Bend at New Road in Waco, TX, your dream apartment awaits! Choose from spacious one and two-bedroom floor plans featuring modern designs, soaring ceilings, and upscale amenities. Enjoy relaxing by the resort-worthy pool or unwinding in our pet-friendly community. Check out our interactive map to start your journey home!",
  "property_pets_blurb": "At Bend at New Road in Waco, TX, your furry friends can thrive alongside you. With spacious homes that accommodate two pets under 80 lbs each, enjoy a vibrant community where tails wag happily. Delve into pet-friendly living with reasonable fees, ensuring a delightful experience for both you and your companions.",
  "property_referafriend_blurb": "At Bend at New Road in Waco, TX, our inviting one and two-bedroom floor plans offer the perfect blend of comfort and style. Great friends make great neighbors—share the warmth of our community today and let your friends experience the vibrant living that awaits them!",
  "property_residentaccess_blurb": "Welcome to Bend at New Road in Waco, TX, where comfort meets community. Choose from our inviting one or two-bedroom floor plans designed for modern living. Log in to your resident portal for easy rent payments, hassle-free maintenance requests, and more—your hassle-free lifestyle starts here!",
  "property_reviews_blurb": "At Bend at New Road in Waco, TX, residents rave about the \"welcoming atmosphere and friendly staff.\" Our vibrant community seamlessly blends comfort and convenience, making it the perfect place to call home. Curious about what else our happy residents are saying? See what our residents have to say about living at our community!",
  "property_created_at": "1770654989886",
  "property_scheduletour_blurb": "At Bend at New Road in Waco, TX, our thoughtfully designed one- and two-bedroom apartments cater to your lifestyle. Embrace the charm of our vibrant community and envision your ideal space. Curious? Schedule a tour today and hear firsthand from our delighted residents about life here!",
  "property_thankyou_blurb": "Thank you for reaching out to Bend at New Road in Waco, TX! Our thoughtfully designed one and two-bedroom floor plans cater to your unique lifestyle. Stay tuned—our friendly team will be in touch soon to guide you in finding your perfect home in our vibrant community.",
  "property_virtualtours_blurb": "Experience the charm of Bend at New Road in Waco, TX! With thoughtfully designed one and two-bedroom floor plans, our community caters to your lifestyle needs. Uncover every detail from the comfort of your home—take a virtual tour today and envision your new beginning in our vibrant apartments!",
  "property_copyright": "2026 All Rights Reserved. Bend at New Road",
  "property_seo_title_home": "Bend at New Road |  Apartments in Waco, TX",
  "property_seo_description_home": "Welcome to Bend at New Road in Waco, TX! Enjoy modern living with spacious floor plans, luxury amenities, and a pet-friendly vibe. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Waco, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Bend at New Road in Waco, TX! Choose from stylish one and two-bedroom floor plans that suit your lifestyle. Browse now!",
  "property_seo_title_amenities": "Amenities | Waco, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at Bend at New Road in Waco, TX. From a resort-style pool to a pet-friendly dog park, our amenities redefine home. Join us today!",
  "property_seo_title_gallery": "Gallery | Apartments in Waco, TX",
  "property_seo_description_gallery": "Experience luxury living at New Road's Waco, TX apartments with modern amenities, spacious layouts, and a pet-friendly community.",
  "property_seo_title_virtualtours": "Virtual Tours | Bend at New Road Apartments",
  "property_seo_description_virtualtours": "Step into your future home at Bend at New Road in Waco, TX. Take a virtual tour of our stunning one and two-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Bend at New Road Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Bend at New Road in Waco, TX. Enjoy resort-style amenities, modern floor plans, and a vibrant community. Your oasis awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Waco, TX",
  "property_seo_description_neighborhood": "Experience Waco, TX at Bend at New Road! Dive into nearby local favorites and hotspots that make our vibrant community your perfect place to call home.",
  "property_seo_title_contact": "Contact Us | Bend at New Road",
  "property_seo_description_contact": "Connect with Bend at New Road in Waco, TX! Our friendly leasing team is ready to assist you with one and two-bedroom floor plans. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Waco, TX",
  "property_seo_description_faqs": "Find answers to all your questions at Bend at New Road! Explore our pet-friendly community amenities and stylish apartment layouts in Waco, TX.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Waco, TX",
  "property_seo_description_reviews": "Experience life at Bend at New Road in Waco, TX! Check out our residents' reviews and see why stylish comfort and community charm define our apartment living.",
  "property_seo_title_applynow": "Apply Now | Apartments in Waco, TX",
  "property_seo_description_applynow": "Find your perfect home at Bend at New Road in Waco, TX! Luxurious floor plans, pet-friendly amenities, and resort-style living await. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Bend at New Road",
  "property_seo_description_residentaccess": "Log in to the Bend at New Road resident portal for easy rent payments, maintenance requests, and community updates. Your Waco home is just a click away!",
  "property_seo_title_referafriend": "Refer A Friend | Bend at New Road",
  "property_seo_description_referafriend": "Refer a friend to Bend at New Road in Waco, TX! Enjoy great neighbors and a vibrant community. Share the love and enrich your living experience today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Bend at New Road",
  "property_seo_description_scheduletour": "Experience Waco living at Bend at New Road! Schedule your tour today to explore our vibrant community and find your perfect home sweet home.",
  "property_seo_title_privacy": "Privacy Policy | Bend at New Road",
  "property_seo_description_privacy": "Your privacy matters at Bend at New Road. Learn how we safeguard your information while you enjoy life in Waco, TX. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Bend at New Road",
  "property_seo_description_accessibility": "At Bend at New Road in Waco, TX, we prioritize accessibility and inclusion, creating a welcoming community for all. Join us in embracing diversity!",
  "property_seo_title_sitemap": "Sitemap | Bend at New Road",
  "property_seo_description_sitemap": "Uncover every detail of Bend at New Road in Waco, TX. Navigate our sitemap for a seamless journey to your future home!",
  "property_seo_title_thankyou": "Thank You | Bend at New Road",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to comfortable living at Bend at New Road in Waco, TX begins now. Our team will be in touch soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Waco, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787864828592",
  "amenities": [
    {
      "id": "ec_6792100f23ba0dba1ac6afca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127396252",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_679fec6c24b9beac47d12ccb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127396253",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eef1f55cce00e184bdff9410",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127396254",
      "title": "24-Hour On-Trend Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a7e7719a87b3bc814a30b459",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127396255",
      "title": "Resort-Worthy Swimming Pool w/ Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dfd651dff242e4ca1c42ed2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127396256",
      "title": "Lush Courtyards w/ Pet Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_274b7951c59946f9d1104d04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127396257",
      "title": "Internet Cafe w/ Complimentary Gourmet Coffee & Tea",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e00870a960a6729b7f3da7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127396258",
      "title": "Relaxing Community Clubhouse w/ Billiards & Shuffleboard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_204f14d7db64dcd70ba99948",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127396259",
      "title": "Gated Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94f6554897c7885db3e9bd2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127396260",
      "title": "Onsite Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dec508d5a599faca8fcdd935",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127396261",
      "title": "Secure Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c92df08fef6ecab51d444ba6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127396262",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_970a39f169db69e303db017c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127396264",
      "title": "Electronic Payments Accepted",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b15d449c71138cbd4502b85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127396265",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96dd84e1675a096793242964",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127396266",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4690139b1b88bcd31ed27080",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397752",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2436d2c04b51ea840ed07db5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397753",
      "title": "Dove Gray or Espresso Brown Custom Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_541792fb741d66d777f62d5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397754",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b307c5062243bbccbd0e54b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397755",
      "title": "Modern LED Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88bb267e4d615d11d836ac1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397756",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ffdf7b9b666667aa6142e205",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397757",
      "title": "Oversized & Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_120ce8f350ae72588d3db5ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397758",
      "title": "Private Patio or Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4efa433626c12b197ee772af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397759",
      "title": "Side-by-Side Refrigerator w/ Ice Maker & Filtered Water",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_279e2c6eacd9b9bb6dfc174b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397760",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea5e425b4b4c8e25397ce5a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397761",
      "title": "Dishwasher & Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e43a5b79bac79923830e409",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397762",
      "title": "Central Heat & Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7904dfcdd014c88f8c36834f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397763",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0bd23ce7c7730d5348180647",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397764",
      "title": "Stylish Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_97f8294ca1281bd193b04c32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397765",
      "title": "Accessible*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5585e6a7fe21d1a84b78f727",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397766",
      "title": "Attached Garages*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6b108182cd20122b884b26f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397767",
      "title": "New & Modern Construction",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64df3e0975fa189dc64d874e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397768",
      "title": "Gas Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca66d0c8c50ace3cd5ff83e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397769",
      "title": "Townhome-Style Living*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd186ca90dfdb017308741e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397770",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0de78236cbe5c54143ea7ae2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397771",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83a0bea67cda0ce4dccbd967",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "yardi",
      "external_id": "127397772",
      "title": "Expansive Living & Layouts",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_dd75f828-511a-46b9-b8c8-7801bd0544fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd83-a4ad-76e8-9f7d-9a72cec9e4cd.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and lounge area at a multifamily property with surrounding buildings.",
        "public_id": "019fcd83-a4ad-76e8-9f7d-9a72cec9e4cd",
        "storage_key": "property/6767906449167035/019fcd83-a4ad-76e8-9f7d-9a72cec9e4cd.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Enjoy the resort-style outdoor swimming pool and spacious lounge area, perfect for relaxing or entertaining at this beautiful multifamily property.",
      "link": "",
      "alt_text": "Outdoor swimming pool and lounge area at a multifamily property with surrounding buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f3f7f6c7-6276-406b-85e3-53ed751b30ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd7c-8c23-73c2-9248-5ba1823a2c63.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical in the apartment gym.",
        "public_id": "019fcd7c-8c23-73c2-9248-5ba1823a2c63",
        "storage_key": "property/6767906449167035/019fcd7c-8c23-73c2-9248-5ba1823a2c63.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring treadmills, ellipticals, and stationary bikes. Enjoy your workout with a view of the pool and surrounding grounds.",
      "link": "",
      "alt_text": "Treadmills and elliptical in the apartment gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_68d68a14-7295-4a2f-8496-1015a975a8c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd7c-4eae-7581-b69e-726e0b0b1e2a.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, and weight machines",
        "public_id": "019fcd7c-4eae-7581-b69e-726e0b0b1e2a",
        "storage_key": "property/6767906449167035/019fcd7c-4eae-7581-b69e-726e0b0b1e2a.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with cardio equipment and weight machines for a great workout.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical, and weight machines",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_909ce10e-0f8a-40a0-b896-5cdb1b27a763",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd7a-c053-754f-b337-08fa46fc6a26.webp",
      "image_media": {
        "alt_text": "Apartment complex with a large sparkling blue swimming pool and lounge chairs.",
        "public_id": "019fcd7a-c053-754f-b337-08fa46fc6a26",
        "storage_key": "property/6767906449167035/019fcd7a-c053-754f-b337-08fa46fc6a26.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the resort-style swimming pool, perfect for relaxing or entertaining. Surrounding lounge chairs offer a comfortable spot to soak up the sun.",
      "link": "",
      "alt_text": "Apartment complex with a large sparkling blue swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3f251cef-fbe1-4370-a183-ffd7f805b2df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd7a-b842-703a-8519-655054b12f34.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building entrance with stone accents and outdoor seating.",
        "public_id": "019fcd7a-b842-703a-8519-655054b12f34",
        "storage_key": "property/6767906449167035/019fcd7a-b842-703a-8519-655054b12f34.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The inviting exterior of our apartment community features a grand entrance with stone details and comfortable outdoor seating areas for residents to enjoy.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building entrance with stone accents and outdoor seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5df3a119-49f4-433c-bc07-64eb6f77c8e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd7a-b831-7384-8354-ae96deb30dbf.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit and turquoise Adirondack chairs.",
        "public_id": "019fcd7a-b831-7384-8354-ae96deb30dbf",
        "storage_key": "property/6767906449167035/019fcd7a-b831-7384-8354-ae96deb30dbf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors with friends and family in this inviting seating area, complete with a cozy fire pit and comfortable Adirondack chairs.",
      "link": "",
      "alt_text": "Outdoor seating area with a fire pit and turquoise Adirondack chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4f4d32b1-0f55-4ecd-b251-69f2a421b9ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd79-6903-754b-a0ec-831794348813.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with balconies and a manicured lawn.",
        "public_id": "019fcd79-6903-754b-a0ec-831794348813",
        "storage_key": "property/6767906449167035/019fcd79-6903-754b-a0ec-831794348813.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Showcasing the elegant exterior of our apartment complex, featuring spacious balconies and beautifully maintained grounds.",
      "link": "",
      "alt_text": "Exterior view of a multi-story apartment building with balconies and a manicured lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_59282d65-d835-4fc6-8ded-4935f0e86397",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd79-15a2-723e-a97f-a40da32d60a1.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lounge chairs with apartment buildings in the background.",
        "public_id": "019fcd79-15a2-723e-a97f-a40da32d60a1",
        "storage_key": "property/6767906449167035/019fcd79-15a2-723e-a97f-a40da32d60a1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling resort-style swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool and lounge chairs with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c6c92320-dd56-4979-8f29-f2f1bdbb9bb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd79-30c1-77e8-81bf-42b031277230.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two stainless steel grills on a stone counter.",
        "public_id": "019fcd79-30c1-77e8-81bf-42b031277230",
        "storage_key": "property/6767906449167035/019fcd79-30c1-77e8-81bf-42b031277230.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with the community's premium grilling station, perfect for gathering with friends and family.",
      "link": "",
      "alt_text": "Outdoor grilling station with two stainless steel grills on a stone counter.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e312480b-1a04-44cf-91a4-e71aa08cf118",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd76-fd3b-72bb-93ac-07724708cdc8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with submerged lounge chairs and tables.",
        "public_id": "019fcd76-fd3b-72bb-93ac-07724708cdc8",
        "storage_key": "property/6767906449167035/019fcd76-fd3b-72bb-93ac-07724708cdc8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, complete with submerged lounge chairs and tables for ultimate relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with submerged lounge chairs and tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8e9ce2fe-7a93-4bc9-9244-d56c3a6d2418",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd72-c824-77a5-b3d8-1d17d43693cb.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, large mirror, toilet, and bathtub with shower.",
        "public_id": "019fcd72-c824-77a5-b3d8-1d17d43693cb",
        "storage_key": "property/6767906449167035/019fcd72-c824-77a5-b3d8-1d17d43693cb.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Step into this stylish bathroom featuring a sleek vanity with a marble-look countertop, a spacious mirror, and a bathtub/shower combo with elegant tiling.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, large mirror, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_425c092c-0ecf-49ce-ad02-33c8136dd708",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd72-3846-76fc-bbef-8ec5ae1c0444.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower with patterned curtain.",
        "public_id": "019fcd72-3846-76fc-bbef-8ec5ae1c0444",
        "storage_key": "property/6767906449167035/019fcd72-3846-76fc-bbef-8ec5ae1c0444.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Step into comfort with this beautifully appointed apartment bathroom, featuring a spacious vanity, modern fixtures, and a stylish shower curtain for a touch of elegance.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and shower with patterned curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1b56fd4b-4e02-4c64-a489-e3da1ab890e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd72-13ba-77ca-bdc6-7839105b90ec.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a wooden bed frame, plush bedding, and stylish decor.",
        "public_id": "019fcd72-13ba-77ca-bdc6-7839105b90ec",
        "storage_key": "property/6767906449167035/019fcd72-13ba-77ca-bdc6-7839105b90ec.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Experience comfort in our beautifully appointed bedrooms, featuring elegant furniture and a serene atmosphere for ultimate relaxation.",
      "link": "",
      "alt_text": "Cozy bedroom with a wooden bed frame, plush bedding, and stylish decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e381f383-6363-4142-8bdf-e1a358eea981",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd71-944b-7393-88bc-571f129ba950.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and gray cabinets",
        "public_id": "019fcd71-944b-7393-88bc-571f129ba950",
        "storage_key": "property/6767906449167035/019fcd71-944b-7393-88bc-571f129ba950.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen featuring sleek gray cabinetry, a full suite of stainless steel appliances, and elegant marble countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and gray cabinets",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a41481d9-47d9-49e4-b18a-877d0ef847fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd71-bc57-709a-971d-4293aa2d02fb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a breakfast bar with leather stools.",
        "public_id": "019fcd71-bc57-709a-971d-4293aa2d02fb",
        "storage_key": "property/6767906449167035/019fcd71-bc57-709a-971d-4293aa2d02fb.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Discover the heart of your home in this sleek, modern kitchen. Featuring stainless steel appliances, ample cabinet storage, and a stylish breakfast bar, it's perfect for casual dining and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a breakfast bar with leather stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dbcb762a-6ed2-4497-a758-a139370a8dc3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd71-005a-721f-9364-a177b45dc709.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and dining area.",
        "public_id": "019fcd71-005a-721f-9364-a177b45dc709",
        "storage_key": "property/6767906449167035/019fcd71-005a-721f-9364-a177b45dc709.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sofa, an armchair, a stylish coffee table, and a separate dining space. Large windows allow natural light to fill the room.",
      "link": "",
      "alt_text": "Living room with a sofa, armchair, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd1a4023-c08a-4f38-905c-854b0fc5a20b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd70-d9a7-72dc-bb12-c26f8b46fc42.webp",
      "image_media": {
        "alt_text": "Cozy living room with a plush sofa, decorative pillows, and a modern coffee table.",
        "public_id": "019fcd70-d9a7-72dc-bb12-c26f8b46fc42",
        "storage_key": "property/6767906449167035/019fcd70-d9a7-72dc-bb12-c26f8b46fc42.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Relax in the spacious and beautifully appointed living area, perfect for entertaining or unwinding after a long day.",
      "link": "",
      "alt_text": "Cozy living room with a plush sofa, decorative pillows, and a modern coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f63cf87-a19a-4c44-aef0-76569918d505",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd70-c321-74ef-9e4f-2632c1d75726.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and a large island sink.",
        "public_id": "019fcd70-c321-74ef-9e4f-2632c1d75726",
        "storage_key": "property/6767906449167035/019fcd70-c321-74ef-9e4f-2632c1d75726.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Enjoy cooking and entertaining in this stylish apartment kitchen, featuring a double basin sink, stainless steel refrigerator, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and a large island sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_93867e29-331a-40d3-8cb9-539d30a9f5b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd70-a042-7589-9ae2-1269abbee8d7.webp",
      "image_media": {
        "alt_text": "Cozy living room with a plush sofa, armchair, and coffee table.",
        "public_id": "019fcd70-a042-7589-9ae2-1269abbee8d7",
        "storage_key": "property/6767906449167035/019fcd70-a042-7589-9ae2-1269abbee8d7.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Relax and unwind in this inviting living room, featuring comfortable seating and modern decor.",
      "link": "",
      "alt_text": "Cozy living room with a plush sofa, armchair, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ba982862-d9e6-4541-a9f8-0abcb77ef17b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd6f-18aa-778f-8308-2d3d51199a10.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-size bed, nightstands, dresser, and ceiling fan.",
        "public_id": "019fcd6f-18aa-778f-8308-2d3d51199a10",
        "storage_key": "property/6767906449167035/019fcd6f-18aa-778f-8308-2d3d51199a10.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious primary bedroom, featuring a king-size bed, ample storage, and elegant decor. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Primary bedroom with a king-size bed, nightstands, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_feeacfb9-c9f3-4871-8ea7-6468094d1926",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd6e-edb7-74b8-a55e-efb8bb5a12b9.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, ceiling fan, and window.",
        "public_id": "019fcd6e-edb7-74b8-a55e-efb8bb5a12b9",
        "storage_key": "property/6767906449167035/019fcd6e-edb7-74b8-a55e-efb8bb5a12b9.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant dresser, and a ceiling fan for year-round comfort.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, ceiling fan, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b03fa126-ceb5-4ef6-a181-53a9f7be22ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd6e-cb33-72db-a19e-690c80b0a0f6.webp",
      "image_media": {
        "alt_text": "Open-concept living room and kitchen with dining area and modern decor.",
        "public_id": "019fcd6e-cb33-72db-a19e-690c80b0a0f6",
        "storage_key": "property/6767906449167035/019fcd6e-cb33-72db-a19e-690c80b0a0f6.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen, dining space, and comfortable seating, perfect for entertaining.",
      "link": "",
      "alt_text": "Open-concept living room and kitchen with dining area and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3ebc0cfc-c933-464d-b2c9-ffa3780483e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd6c-d79c-771f-9ea5-7a0e6f808f66.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and four chairs",
        "public_id": "019fcd6c-d79c-771f-9ea5-7a0e6f808f66",
        "storage_key": "property/6767906449167035/019fcd6c-d79c-771f-9ea5-7a0e6f808f66.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a round table and four upholstered chairs, perfect for intimate meals or entertaining.",
      "link": "",
      "alt_text": "Dining area with a round table and four chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e08b92b4-aa3b-4d03-bfd4-41340e6cccc0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd6c-aa39-743a-9e3f-a10624ab47ee.webp",
      "image_media": {
        "alt_text": "Cozy living room with a green sofa, armchair, coffee table, and dining area.",
        "public_id": "019fcd6c-aa39-743a-9e3f-a10624ab47ee",
        "storage_key": "property/6767906449167035/019fcd6c-aa39-743a-9e3f-a10624ab47ee.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully furnished living room, complete with a plush sofa, accent chair, and a separate dining space.",
      "link": "",
      "alt_text": "Cozy living room with a green sofa, armchair, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a7b36c8f-6321-476d-bee0-5ad0999a4f52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019fcd6c-7454-700b-90ba-dbea8f5f9d67.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a marble island.",
        "public_id": "019fcd6c-7454-700b-90ba-dbea8f5f9d67",
        "storage_key": "property/6767906449167035/019fcd6c-7454-700b-90ba-dbea8f5f9d67.webp",
        "width": 3072,
        "height": 2458
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this stylish kitchen featuring stainless steel appliances, ample cabinet space, and a sleek marble-topped island perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a marble island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_cd939244-734a-4662-85c7-ad6883472c32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Magnolia Table",
      "poi_type": "Restaurants",
      "poi_address": "2132 S Valley Mills Dr, Waco, TX 76706, USA",
      "poi_short_description": "Hip setting for breakfast & lunch with nearby garden & farm ingredients plus prepared food to-go.",
      "poi_long_description": "People say this restaurant serves delicious biscuits, chicken tenders, and French toast. They highlight the generous portions, the beautiful and clean atmosphere, and the friendly staff. They also like the attentive service and the option to make reservations. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-5ecd-74fb-9281-c0bb719cd336.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-5ecd-74fb-9281-c0bb719cd336",
        "storage_key": "property/6767906449167035/019cfb50-5ecd-74fb-9281-c0bb719cd336.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://magnolia.com/visit/eat/magnolia-table/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15024825786996619514&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "magnolia-table",
      "poi_latitude": "31.5245913",
      "poi_longitude": "-97.1326488",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 254-265-6859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fde-745b-a437-085c381137ba",
        "storage_key": "property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZXt4pCuCT4YR-vgPxnLngtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b960f71c-a4d8-41c8-860c-5c569642e4a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Terry Black's Barbecue Waco",
      "poi_type": "Restaurants",
      "poi_address": "228 S 8th St, Waco, TX 76701, USA",
      "poi_short_description": "Laid-back locale specializing in brisket and other smoked meats, as well as sides, desserts and drinks.",
      "poi_long_description": "People say this barbecue restaurant serves delicious brisket, ribs, sausage, and turkey, with sides like mac and cheese, potato salad, and creamed corn. They highlight the generous portions, the cool atmosphere with indoor and outdoor seating, and the friendly, attentive staff. They also like the homemade barbecue sauces and the opportunity to watch the pitmasters tend to the smokers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a044-730a-a199-54317374a0c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a044-730a-a199-54317374a0c5",
        "storage_key": "property/6767906449167035/019cfb50-a044-730a-a199-54317374a0c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://terryblacksbbq.com/waco",
      "poi_directions_map_url": "https://maps.google.com/?cid=5712016703986193757&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "terry-blacks-barbecue-waco",
      "poi_latitude": "31.5532849",
      "poi_longitude": "-97.1325342",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-300-5690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fde-745b-a437-085c381137ba",
        "storage_key": "property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl1hU9QiDT4YRXdUxwO0oRU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_81e56e24-7b7f-40a6-bd11-1558b9a76932",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "801 S 4th St, Waco, TX 76706, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, including the popular \"Flying Dutchman\" and \"Animal Style\" options, and fresh-cut fries. They highlight the affordable prices and the fast, friendly service. They also like the clean and lively atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-9feb-764e-9f85-7c18b604616f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-9feb-764e-9f85-7c18b604616f",
        "storage_key": "property/6767906449167035/019cfb50-9feb-764e-9f85-7c18b604616f.webp",
        "width": 1280,
        "height": 680
      },
      "poi_business_url": "https://locations.in-n-out.com/307",
      "poi_directions_map_url": "https://maps.google.com/?cid=12848417709831099316&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "31.5511551",
      "poi_longitude": "-97.1240726",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fde-745b-a437-085c381137ba",
        "storage_key": "property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRTSSjUWCT4YRtBNSUNW_TrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_e8c38478-e99f-4313-9352-9f0cee47cb27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "George’s Restaurant Bar & Catering",
      "poi_type": "Restaurants",
      "poi_address": "1925 Speight Ave, Waco, TX 76706, USA",
      "poi_short_description": "Old-school operation offering hearty American fare & drinks in a TV-equipped space.",
      "poi_long_description": "People say this American restaurant serves great chicken fried steak, onion rings, and fried okra. They highlight the generous portions, affordable prices, and fun, relaxed atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-61f1-764f-b5f2-c75bbfaa059b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-61f1-764f-b5f2-c75bbfaa059b",
        "storage_key": "property/6767906449167035/019cfb50-61f1-764f-b5f2-c75bbfaa059b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://georgesrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3208701387611377180&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "georges-restaurant-bar--catering",
      "poi_latitude": "31.53403",
      "poi_longitude": "-97.13197",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 254-753-1421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fde-745b-a437-085c381137ba",
        "storage_key": "property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCZu4QDKCT4YRHA7hXumYhyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_7d2ae97a-fa21-43f2-a12c-7915bc2eb141",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2815 La Salle Ave, Waco, TX 76706, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious chicken fried steak, prime rib, and ribs. They also highlight the quick service, friendly staff, and reasonable prices.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a044-730a-a199-530af5af3627.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a044-730a-a199-530af5af3627",
        "storage_key": "property/6767906449167035/019cfb50-a044-730a-a199-530af5af3627.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/waco?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3955079780772252221&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "31.5225365",
      "poi_longitude": "-97.1340146",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 254-662-1177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fde-745b-a437-085c381137ba",
        "storage_key": "property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSsW7iqCT4YRPYpCDxtE4zY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_3b37b4c1-8653-424e-852f-2437b90b2985",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "H-E-B plus!",
      "poi_type": "Shopping & Retail",
      "poi_address": "1821 S Valley Mills Dr, Waco, TX 76711, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, meats, baked goods, and pre-seasoned options, as well as home supplies. They highlight the fair prices, the clean and well-organized layout, and the convenient curbside pickup service. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-62e4-7767-a645-1a09d22f9590.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-62e4-7767-a645-1a09d22f9590",
        "storage_key": "property/6767906449167035/019cfb50-62e4-7767-a645-1a09d22f9590.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/waco/valley-mills-h-e-b-plus--672?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=14018785604489557153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-e-b-plus",
      "poi_latitude": "31.5230195",
      "poi_longitude": "-97.1372826",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 254-710-9400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fed-7278-88a3-bfe48bf9b02a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fed-7278-88a3-bfe48bf9b02a",
        "storage_key": "property/6767906449167035/019cfb50-7fed-7278-88a3-bfe48bf9b02a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9Y9uC9qDT4YRobT1iTu7jMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6936276f-b13f-48c6-8ad3-330ed28da317",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Richland Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 W Waco Dr, Waco, TX 76710, USA",
      "poi_short_description": "Low-key indoor mall with a familiar range of chain retailers & department stores, plus a food court.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and a thriving atmosphere. They also highlight the convenient layout, easy parking, and friendly staff.\n\nOther reviews mention the mall can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-663c-748f-9fac-37a6035e4319.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-663c-748f-9fac-37a6035e4319",
        "storage_key": "property/6767906449167035/019cfb50-663c-748f-9fac-37a6035e4319.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.richlandmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4753002464235028715&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "richland-mall",
      "poi_latitude": "31.5164049",
      "poi_longitude": "-97.188648",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-776-6631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff9-7309-a862-4dfeb905a566.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff9-7309-a862-4dfeb905a566",
        "storage_key": "property/6767906449167035/019cfb50-7ff9-7309-a862-4dfeb905a566.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2ZnYRqiGT4YR6wBJCY8O9kE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_3b141b58-9add-447f-9c98-d893ba439859",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "1301 Wooded Acres Dr, Waco, TX 76710, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Shoppers say this grocery store offers a wide variety of products at affordable prices, and they praise the fresh produce, delicious bakery items, and top-notch meat selection. They also highlight the friendly and helpful staff, and the clean and well-stocked store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a010-7759-a68c-50ef6e6f794c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a010-7759-a68c-50ef6e6f794c",
        "storage_key": "property/6767906449167035/019cfb50-a010-7759-a68c-50ef6e6f794c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/waco/wooded-acres-h-e-b-423?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=9365767768359474083&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "31.533912",
      "poi_longitude": "-97.188173",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 254-776-7040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fed-7278-88a3-bfe48bf9b02a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fed-7278-88a3-bfe48bf9b02a",
        "storage_key": "property/6767906449167035/019cfb50-7fed-7278-88a3-bfe48bf9b02a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSwX6IQ6ET4YRo5Pe0Snk-YE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_459eed1c-922e-4e54-890d-3f1d87d648a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Baylor University",
      "poi_type": "Education",
      "poi_address": "1311 S 5th St, Waco, TX 76706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a2a1-748c-a47f-89a95c43e694.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a2a1-748c-a47f-89a95c43e694",
        "storage_key": "property/6767906449167035/019cfb50-a2a1-748c-a47f-89a95c43e694.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.baylor.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7163770527817390045&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "baylor-university",
      "poi_latitude": "31.5500848",
      "poi_longitude": "-97.11354",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-229-5678",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fe8-7219-bf94-8a16dd8d5462",
        "storage_key": "property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkebHSWqCT4YR3df3-lbTamM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_62d5e57f-65c8-44b2-8c06-f51102bc8f60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "McLennan Community College",
      "poi_type": "Education",
      "poi_address": "1400 College Dr, Waco, TX 76708, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-682d-77be-95d2-b83ba19843e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-682d-77be-95d2-b83ba19843e9",
        "storage_key": "property/6767906449167035/019cfb50-682d-77be-95d2-b83ba19843e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mclennan.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8969860626952648163&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mclennan-community-college",
      "poi_latitude": "31.5896872",
      "poi_longitude": "-97.1726695",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 254-299-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fe8-7219-bf94-8a16dd8d5462",
        "storage_key": "property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIUtYSVyDT4YR43VGQrdYe3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4f67f6f2-8a86-41ae-a3d3-48649f87239c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Moody Memorial Library",
      "poi_type": "Education",
      "poi_address": "1312 S 3rd St, Waco, TX 76798, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a252-770d-b280-684b574d51ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a252-770d-b280-684b574d51ef",
        "storage_key": "property/6767906449167035/019cfb50-a252-770d-b280-684b574d51ef.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.baylor.edu/library/moodyjones",
      "poi_directions_map_url": "https://maps.google.com/?cid=7800864692600987949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "moody-memorial-library",
      "poi_latitude": "31.5488251",
      "poi_longitude": "-97.1177558",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-710-6702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-83d1-7721-b520-dde9c945623a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-83d1-7721-b520-dde9c945623a",
        "storage_key": "property/6767906449167035/019cfb50-83d1-7721-b520-dde9c945623a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpa7dQ0GCT4YRLWFebxs9Qmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_a7a0dfb8-0828-4032-8552-5b8394fd1b99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Waco-McLennan County Library Central Library",
      "poi_type": "Education",
      "poi_address": "1717 Austin Ave, Waco, TX 76701, USA",
      "poi_short_description": "Public library with indoor and outdoor seating offering books, movies, and a variety of materials to borrow.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a2da-727f-a9e4-c8718fdad3ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a2da-727f-a9e4-c8718fdad3ef",
        "storage_key": "property/6767906449167035/019cfb50-a2da-727f-a9e4-c8718fdad3ef.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.wacolibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17865099954342392677&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "waco-mclennan-county-library-central-library",
      "poi_latitude": "31.5467586",
      "poi_longitude": "-97.1437399",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-750-5941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fe8-7219-bf94-8a16dd8d5462",
        "storage_key": "property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmatj47aDT4YRZfNsT8GV7fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_4c9cbcb9-e0f9-4a21-90e8-50459ac7615b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Hankamer School of Business",
      "poi_type": "Education",
      "poi_address": "1621 S 3rd St, Waco, TX 76706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a43a-7334-a7a0-2fd6acca70d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a43a-7334-a7a0-2fd6acca70d9",
        "storage_key": "property/6767906449167035/019cfb50-a43a-7334-a7a0-2fd6acca70d9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://hankamer.baylor.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3762960749010751522&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hankamer-school-of-business",
      "poi_latitude": "31.545179",
      "poi_longitude": "-97.115267",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-710-3411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fe8-7219-bf94-8a16dd8d5462",
        "storage_key": "property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb6DGwUCCT4YRIhCGPN24ODQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_d8eb95ee-6d27-4f11-8a79-4575cdc2d3dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Dr Pepper Museum",
      "poi_type": "Entertainment",
      "poi_address": "300 S 5th St, Waco, TX 76701, USA",
      "poi_short_description": "Nonprofit gallery examining the history & memorabilia of soft drinks in a 1906 bottling plant.",
      "poi_long_description": "People say this museum offers a self-guided tour with informative exhibits, memorabilia, and a soda fountain where visitors can enjoy a free drink or purchase floats. They also highlight the reasonable admission price, the interactive soda-making experience, and the friendly staff.\n\nOther reviews mention the museum can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-6a5d-71ef-aba6-01d951067634.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-6a5d-71ef-aba6-01d951067634",
        "storage_key": "property/6767906449167035/019cfb50-6a5d-71ef-aba6-01d951067634.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.drpeppermuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11954819412563611991&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dr-pepper-museum",
      "poi_latitude": "31.5551583",
      "poi_longitude": "-97.1295999",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-757-1024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff9-7309-a862-51dd3435b2b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff9-7309-a862-51dd3435b2b2",
        "storage_key": "property/6767906449167035/019cfb50-7ff9-7309-a862-51dd3435b2b2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOakuHk6CT4YRV1HMl-oM6KU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f0dcb843-3754-4c56-b209-89610e01dadf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Cameron Park Zoo",
      "poi_type": "Entertainment",
      "poi_address": "1701 N 4th St, Waco, TX 76707, USA",
      "poi_short_description": "Verdant, 52-acre zoo featuring numerous wild animals plus a gift shop, cafes & events.",
      "poi_long_description": "People say this zoo offers a wide variety of animals and exhibits, and is a fun place for families. They highlight the reasonable prices, the well-maintained grounds, and the shaded walking paths. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-69f4-7222-b12c-b963c9785ddb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-69f4-7222-b12c-b963c9785ddb",
        "storage_key": "property/6767906449167035/019cfb50-69f4-7222-b12c-b963c9785ddb.webp",
        "width": 960,
        "height": 422
      },
      "poi_business_url": "http://www.cameronparkzoo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13803951944348861414&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cameron-park-zoo",
      "poi_latitude": "31.5701472",
      "poi_longitude": "-97.1445667",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 254-750-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff2-700a-9735-576e18aca7c7",
        "storage_key": "property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSJ7CQaDT4YR5gN6Kyh9kb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_412276f2-d3d0-41fd-8243-5af04a428370",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "McLane Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1001 S M.L.K. Jr Blvd, Waco, TX 76704, USA",
      "poi_short_description": "Sports stadium featuring clean restrooms, food and drink sold at various outlets, as well as modern amenities, such as tailgating.",
      "poi_long_description": "Fans say this stadium is a great place to watch the Baylor Bears play football, and they appreciate the free water stations, plentiful restrooms, and easy access. They also highlight the friendly and helpful staff, as well as the respectful and hospitable Baylor fan base.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a527-776d-ac4a-139358a552c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a527-776d-ac4a-139358a552c5",
        "storage_key": "property/6767906449167035/019cfb50-a527-776d-ac4a-139358a552c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mclanestadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=948108573633282188&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mclane-stadium",
      "poi_latitude": "31.5582015",
      "poi_longitude": "-97.1156702",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-710-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-b3a7-77e0-b7ab-463b89ece4ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b3a7-77e0-b7ab-463b89ece4ec",
        "storage_key": "property/6767906449167035/019cfb50-b3a7-77e0-b7ab-463b89ece4ec.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLRpHmF2CT4YRjADqc7lbKA0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_e9f3692a-5c54-4c5a-a7b2-8a3b2eb72394",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Mayborn Museum Complex",
      "poi_type": "Entertainment",
      "poi_address": "1300 S University Parks Dr, Waco, TX 76706, USA",
      "poi_short_description": "Exhibits exploring science, natural history & communications, plus a 19th-century village.",
      "poi_long_description": "People say this museum offers a wide variety of interactive exhibits and activities, including a popular bubble room, suitable for children and adults. They highlight the educational and fun experience, and the opportunity to learn about local history and culture. They also like the friendly and informative staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-66bd-7519-b2ae-a9be8d100abf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-66bd-7519-b2ae-a9be8d100abf",
        "storage_key": "property/6767906449167035/019cfb50-66bd-7519-b2ae-a9be8d100abf.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://www.baylor.edu/mayborn/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3457497109688938317&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mayborn-museum-complex",
      "poi_latitude": "31.5518639",
      "poi_longitude": "-97.11499200000002",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-710-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff9-7309-a862-51dd3435b2b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff9-7309-a862-51dd3435b2b2",
        "storage_key": "property/6767906449167035/019cfb50-7ff9-7309-a862-51dd3435b2b2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ63G-TEKCT4YRTe_yek1_-y8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6b9ee8c5-7bf9-4057-877f-4c0b8be5db03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Texas Ranger Hall of Fame & Museum",
      "poi_type": "Entertainment",
      "poi_address": "100 Texas Ranger Trail, Waco, TX 76706, USA",
      "poi_short_description": "Paean to famed lawmen features history, artifacts, photos & more, plus programs & a research center.",
      "poi_long_description": "People say this heritage museum offers a fascinating collection of artifacts, memorabilia, and exhibits showcasing the history of the Texas Rangers. They highlight the informative scavenger hunt, the interesting movie, and the well-curated displays. They also like the friendly staff and the reasonably priced gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-6ad0-70aa-89d0-36e701cfe10c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-6ad0-70aa-89d0-36e701cfe10c",
        "storage_key": "property/6767906449167035/019cfb50-6ad0-70aa-89d0-36e701cfe10c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.texasranger.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=868283811813356774&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-ranger-hall-of-fame--museum",
      "poi_latitude": "31.5555471",
      "poi_longitude": "-97.1187182",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-750-8631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff9-7309-a862-51dd3435b2b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff9-7309-a862-51dd3435b2b2",
        "storage_key": "property/6767906449167035/019cfb50-7ff9-7309-a862-51dd3435b2b2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJG6rUSkOCT4YR5nRbx4bDDAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4d9740aa-0664-4e2a-a6a7-b4137d103628",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "300 N Valley Mills Dr, Waco, TX 76710, USA",
      "poi_short_description": "Chain of clean, down-to-earth gyms featuring cardio equipment, locker rooms and tanning machines.",
      "poi_long_description": "People say this gym offers a wide variety of workout equipment and supplements. They highlight the clean and well-maintained facilities, and the welcoming and less intimidating atmosphere. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-707e-73ac-90ee-8c9da15a4138.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-707e-73ac-90ee-8c9da15a4138",
        "storage_key": "property/6767906449167035/019cfb50-707e-73ac-90ee-8c9da15a4138.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/waco-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4080706577757134135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.52663759999999",
      "poi_longitude": "-97.166908",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 254-224-5203",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff2-700a-9735-576e18aca7c7",
        "storage_key": "property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMYZg6-SDT4YRN13QDwOVoTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_21de404a-4669-42d0-8d09-33b582695167",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Crunch Fitness - Waco",
      "poi_type": "Health and Wellness",
      "poi_address": "575 N Valley Mills Dr, Waco, TX 76710, USA",
      "poi_short_description": "Chain fitness center offering classes, weights and machines.",
      "poi_long_description": "People say this gym offers a large variety of well-maintained equipment and a dedicated boxing area. They also highlight the friendly and helpful staff, and the clean facilities, including tanning beds.\n\nOther reviews mention the gym can be crowded during peak hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a6d8-741f-828d-4b305c903be8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a6d8-741f-828d-4b305c903be8",
        "storage_key": "property/6767906449167035/019cfb50-a6d8-741f-828d-4b305c903be8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crunch.com/locations/waco",
      "poi_directions_map_url": "https://maps.google.com/?cid=1072343148433953578&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---waco",
      "poi_latitude": "31.529965",
      "poi_longitude": "-97.1730913",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-265-8265",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff2-700a-9735-576e18aca7c7",
        "storage_key": "property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB-4e4W2DT4YRKtO6d2m64Q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_aff7669f-93f1-4be3-98c3-e8f43ad6d331",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Animal Birth Control Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "3238 Clay Ave, Waco, TX 76711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a6d5-739b-8a3c-b34237e44196.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a6d5-739b-8a3c-b34237e44196",
        "storage_key": "property/6767906449167035/019cfb50-a6d5-739b-8a3c-b34237e44196.webp",
        "width": 1280,
        "height": 1011
      },
      "poi_business_url": "http://www.animalbirthcontrol.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9491659999051597985&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "animal-birth-control-clinic",
      "poi_latitude": "31.5277316",
      "poi_longitude": "-97.1531023",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-776-7303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff2-700a-9735-5365ba6c3927.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff2-700a-9735-5365ba6c3927",
        "storage_key": "property/6767906449167035/019cfb50-7ff2-700a-9735-5365ba6c3927.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj5a7aNyDT4YRoUhB7HomuYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_01c5f1c7-85fb-47d5-aac7-8d5da701489f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Butler's Barber Lounge",
      "poi_type": "Health and Wellness",
      "poi_address": "1521 Wooded Acres Dr Suite A, Waco, TX 76710, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a73a-7724-943b-a651138c8371.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a73a-7724-943b-a651138c8371",
        "storage_key": "property/6767906449167035/019cfb50-a73a-7724-943b-a651138c8371.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.butlersbarberlounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16256636256258416199&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "butlers-barber-lounge",
      "poi_latitude": "31.5353565",
      "poi_longitude": "-97.1905059",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 254-224-6781",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff2-700a-9735-576e18aca7c7",
        "storage_key": "property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqRBtStKFT4YRR94EMYssm-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_0b9759a2-5892-4b2d-aedd-a1049bf0a5ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "McLane Student Life Center- SLC",
      "poi_type": "Health and Wellness",
      "poi_address": "McLane Student Life Center, 209 Speight Ave, Waco, TX 76706, USA",
      "poi_short_description": "Recreation center featuring basketball and racquetball courts, a pool, and a weight room.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a736-73df-b36b-46f61e05b2f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a736-73df-b36b-46f61e05b2f3",
        "storage_key": "property/6767906449167035/019cfb50-a736-73df-b36b-46f61e05b2f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.baylor.edu/campusrec/index.php?id=928396",
      "poi_directions_map_url": "https://maps.google.com/?cid=5921233752644781204&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mclane-student-life-center--slc",
      "poi_latitude": "31.5473935",
      "poi_longitude": "-97.1141152",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 254-710-7542",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff2-700a-9735-576e18aca7c7",
        "storage_key": "property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkaSygGqCT4YRlARy2rlyLFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c79b2341-5c08-45bd-9e70-379c0bbdee61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Texas Dynasty Cheer & Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "800 Schroeder Dr Suite C, Waco, TX 76710, USA",
      "poi_short_description": "Spacious venue for gymnastics and cheerleading, featuring classes and parties.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a6fa-711f-acb8-3a776821bff7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a6fa-711f-acb8-3a776821bff7",
        "storage_key": "property/6767906449167035/019cfb50-a6fa-711f-acb8-3a776821bff7.webp",
        "width": 768,
        "height": 1024
      },
      "poi_business_url": "http://txdynasty.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10922492512142983377&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-dynasty-cheer--gymnastics",
      "poi_latitude": "31.51086889999999",
      "poi_longitude": "-97.173836",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-776-6248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fe8-7219-bf94-8a16dd8d5462",
        "storage_key": "property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoxbCvqqGT4YR0YAl6BF9lJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_763610ea-55e1-4b63-84cd-401d9c35f2d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Waco Animal Emergency Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "3901 Jack Kultgen Fwy, Waco, TX 76706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a7ac-73fb-8e67-364f3a071b44.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a7ac-73fb-8e67-364f3a071b44",
        "storage_key": "property/6767906449167035/019cfb50-a7ac-73fb-8e67-364f3a071b44.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://wacoanimalemergencyclinic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7742041022524351834&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "waco-animal-emergency-clinic",
      "poi_latitude": "31.5114638",
      "poi_longitude": "-97.1418971",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 254-752-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff2-700a-9735-576e18aca7c7",
        "storage_key": "property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKWX0LXqBT4YRWuUQeEpBcWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_11aba4d8-f788-4fc0-9b3e-8601ef018681",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Southern Swings Nail & Wine Bar Waco",
      "poi_type": "Health and Wellness",
      "poi_address": "501 S 8th St, Waco, TX 76706, USA",
      "poi_short_description": "Nail and beauty salon, featuring swinging chairs for pedicures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a818-7479-a5c3-1576b79d7ae3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a818-7479-a5c3-1576b79d7ae3",
        "storage_key": "property/6767906449167035/019cfb50-a818-7479-a5c3-1576b79d7ae3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.southernswingsnailbarwaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7160261195025307661&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southern-swings-nail--wine-bar-waco",
      "poi_latitude": "31.5509934",
      "poi_longitude": "-97.1305695",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-294-8241",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff2-700a-9735-576e18aca7c7",
        "storage_key": "property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UP5L3yDT4YRDVh_xJ5bXmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_ddeca871-1c4a-45e8-888f-96b0d6d9055f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Gold's Gym Waco",
      "poi_type": "Health and Wellness",
      "poi_address": "250 N New Rd, Waco, TX 76710, USA",
      "poi_short_description": "Chain fitness center offering weight machines, cardio equipment, and personal trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-6fc1-70a3-a942-3030e5ad01e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-6fc1-70a3-a942-3030e5ad01e0",
        "storage_key": "property/6767906449167035/019cfb50-6fc1-70a3-a942-3030e5ad01e0.webp",
        "width": 1024,
        "height": 597
      },
      "poi_business_url": "https://www.goldsgym.com/wacotx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10121885265704463436&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golds-gym-waco",
      "poi_latitude": "31.5237946",
      "poi_longitude": "-97.172795",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-399-9393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff2-700a-9735-576e18aca7c7",
        "storage_key": "property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy9RClPyDT4YRTCyTZwUpeIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_014a643c-d8ac-4a5a-bde9-0c6e80597b5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Cottonwood Creek Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2200 TX-340 Loop South, Waco, TX 76706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-a9aa-74cd-b586-eb09f04fcecc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-a9aa-74cd-b586-eb09f04fcecc",
        "storage_key": "property/6767906449167035/019cfb50-a9aa-74cd-b586-eb09f04fcecc.webp",
        "width": 851,
        "height": 315
      },
      "poi_business_url": "http://ccvethosp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10081882927965432583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cottonwood-creek-veterinary-hospital",
      "poi_latitude": "31.5088267",
      "poi_longitude": "-97.1016675",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 254-757-0460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff2-700a-9735-576e18aca7c7",
        "storage_key": "property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbSEfg--BT4YRB2t0XBsL6os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_9ff83c19-3a73-4a8c-be8b-816f986e0413",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Baylor Scott & White Medical Center - Hillcrest",
      "poi_type": "Health and Wellness",
      "poi_address": "100 Hillcrest Medical Blvd, Waco, TX 76712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-6c38-714f-836e-cbe53fa2383b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-6c38-714f-836e-cbe53fa2383b",
        "storage_key": "property/6767906449167035/019cfb50-6c38-714f-836e-cbe53fa2383b.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.bswhealth.com/locations/hospital/hillcrest?utm_source=pg-google&utm_medium=organic&utm_campaign=29985-3814861",
      "poi_directions_map_url": "https://maps.google.com/?cid=8216934832998146127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "baylor-scott--white-medical-center---hillcrest",
      "poi_latitude": "31.4890068",
      "poi_longitude": "-97.1576836",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 254-202-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-83ba-7568-9d7f-22e8c34f4eb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-83ba-7568-9d7f-22e8c34f4eb6",
        "storage_key": "property/6767906449167035/019cfb50-83ba-7568-9d7f-22e8c34f4eb6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyaGo4T2BT4YRT2BjB7JqCHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_07ecf144-16af-4ffe-a03d-ae9314f544fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Ascension Providence Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6901 Medical Pkwy, Waco, TX 76712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7a11-7503-b9b6-616254f4cdee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-7a11-7503-b9b6-616254f4cdee",
        "storage_key": "property/6767906449167035/019cfb50-7a11-7503-b9b6-616254f4cdee.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/texas/txwac/waco-ascension-providence-hospital?utm_campaign=gmb&utm_medium=organic-search&utm_content=location-listing&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6492679134749646913&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ascension-providence-hospital",
      "poi_latitude": "31.5136822",
      "poi_longitude": "-97.1991448",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-751-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-83ba-7568-9d7f-22e8c34f4eb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-83ba-7568-9d7f-22e8c34f4eb6",
        "storage_key": "property/6767906449167035/019cfb50-83ba-7568-9d7f-22e8c34f4eb6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJGRliM6CGT4YRQeBX-0WhGlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d988319b-75f5-42e7-81e2-ad7600701036",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Cameron Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2601 N University Parks Dr, Waco, TX 76708, USA",
      "poi_short_description": "400-acre park featuring 2 rivers, cliffs & playgrounds, plus hiking, biking & festival areas.",
      "poi_long_description": "People say this city park offers a variety of trails for hiking, biking, and running, as well as playgrounds, splash pads, and scenic views of the Brazos River. They highlight the well-maintained trails, the diverse options for activities, and the beautiful scenery. They also like the peaceful and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7482-71b8-996b-5f92805f203c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-7482-71b8-996b-5f92805f203c",
        "storage_key": "property/6767906449167035/019cfb50-7482-71b8-996b-5f92805f203c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.waco-texas.com/Departments/Parks-Recreation/Cameron-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1509339208401902560&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cameron-park",
      "poi_latitude": "31.5836578",
      "poi_longitude": "-97.1562575",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 254-750-5980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-83bd-72f6-a798-67abb1f89dee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-83bd-72f6-a798-67abb1f89dee",
        "storage_key": "property/6767906449167035/019cfb50-83bd-72f6-a798-67abb1f89dee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW5jISRODT4YR4FtdYgNA8hQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3497d519-9856-4ea5-96cd-61a193824abc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Cottonwood Creek Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5200 Bagby Ave, Waco, TX 76711, USA",
      "poi_short_description": "Casual public course with a pro shop stocking golf gear & accessories, plus club fittings & repairs.",
      "poi_long_description": "People say this golf course is beautiful and forgiving. They also highlight the course is well-maintained and in excellent condition.\n\nOther reviews mention the staff can be impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-ad77-767b-b7f6-b908279e50e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ad77-767b-b7f6-b908279e50e2",
        "storage_key": "property/6767906449167035/019cfb50-ad77-767b-b7f6-b908279e50e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.waco-texas.com/cottonwood",
      "poi_directions_map_url": "https://maps.google.com/?cid=2026844058063726421&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cottonwood-creek-golf-course",
      "poi_latitude": "31.5064126",
      "poi_longitude": "-97.1617916",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 254-745-6009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-b4f2-731e-aefd-3f578d09187c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-b4f2-731e-aefd-3f578d09187c",
        "storage_key": "property/6767906449167035/019cfb50-b4f2-731e-aefd-3f578d09187c.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJk7hY4kKBT4YRVef_n-7LIBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_5c58c550-9e72-494c-9013-99f08cd74599",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Woodway Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1625 Estates Dr, Woodway, TX 76712, USA",
      "poi_short_description": "City park featuring a disc-golf course, 2 pavilions with BBQ grills, a playground & lake views.",
      "poi_long_description": "People say this city park offers scenic hiking trails through the woods and along the lake shore, and is a great place to enjoy a sunset. They highlight the spacious and peaceful vibe, suitable for relaxation and family time. They also like the well-maintained trails and the easy access to the lake. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-ad38-774a-a586-66b2cbc0ddeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ad38-774a-a586-66b2cbc0ddeb",
        "storage_key": "property/6767906449167035/019cfb50-ad38-774a-a586-66b2cbc0ddeb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://discoverwoodway.com/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2535205004088397821&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodway-park",
      "poi_latitude": "31.5222564",
      "poi_longitude": "-97.2338532",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 254-772-4050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-83bd-72f6-a798-67abb1f89dee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-83bd-72f6-a798-67abb1f89dee",
        "storage_key": "property/6767906449167035/019cfb50-83bd-72f6-a798-67abb1f89dee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu45KvHuGT4YR_U975YTbLiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b3ad4af9-6045-48b2-9539-c454fd17e82f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Jacob's Ladder",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2500 Cameron Park Dr, Waco, TX 76708, USA",
      "poi_short_description": "Park with picnic tables and a popular set of stairs providing a workout and scenic views.",
      "poi_long_description": "People say this park offers a challenging climb with uneven steps, a river path, and a playground. They highlight the beautiful views, the fun and exciting walks, and the great workout. They also like the scenic area and the opportunity to get blood circulating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-ade2-717f-81bf-c84594bc86b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ade2-717f-81bf-c84594bc86b5",
        "storage_key": "property/6767906449167035/019cfb50-ade2-717f-81bf-c84594bc86b5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.waco-texas.com/Departments/Parks-Recreation/Cameron-Park/Cameron-Park-Points-of-Interest",
      "poi_directions_map_url": "https://maps.google.com/?cid=5046674195203821189&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jacobs-ladder",
      "poi_latitude": "31.577538",
      "poi_longitude": "-97.1493446",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 254-750-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-83bd-72f6-a798-67abb1f89dee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-83bd-72f6-a798-67abb1f89dee",
        "storage_key": "property/6767906449167035/019cfb50-83bd-72f6-a798-67abb1f89dee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2aBLRCDT4YRhQ5BLnFjCUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1c614c98-e350-4fb2-9300-d3a072e69ea6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Whitehall Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Whitehall Park, 7600 Fresno Rd, Woodway, TX 76712, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a variety of amenities, including playgrounds for children of all ages, tennis courts, a dog park, and a walking track. They highlight the clean restrooms, water fountains for people and dogs, and shaded areas with a free book nook. They also like the ample space for picnics and the availability of sidewalk chalk.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-ad7c-7337-9f56-b210363926c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ad7c-7337-9f56-b210363926c0",
        "storage_key": "property/6767906449167035/019cfb50-ad7c-7337-9f56-b210363926c0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://discoverwoodway.com/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=605218144821514294&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whitehall-park",
      "poi_latitude": "31.5083728",
      "poi_longitude": "-97.2090007",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 254-772-4050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-83bd-72f6-a798-67abb1f89dee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-83bd-72f6-a798-67abb1f89dee",
        "storage_key": "property/6767906449167035/019cfb50-83bd-72f6-a798-67abb1f89dee.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____A5uGT4YRNhC1NbIqZgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b16e776a-12a8-4a71-9e6d-1a94d55b7be3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Waco City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 Austin Ave, Waco, TX 76702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ba3-75fd-a40f-86a85772c0b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ba3-75fd-a40f-86a85772c0b1",
        "storage_key": "property/6767906449167035/019cfb50-7ba3-75fd-a40f-86a85772c0b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.waco-texas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8267798876937024994&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "waco-city-hall",
      "poi_latitude": "31.5587515",
      "poi_longitude": "-97.1295862",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-750-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-83d1-7721-b520-dde9c945623a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-83d1-7721-b520-dde9c945623a",
        "storage_key": "property/6767906449167035/019cfb50-83d1-7721-b520-dde9c945623a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwz9QVGCT4YR4nU0HkYfvXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_c4e641d7-526e-47cf-b082-db60639b98e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Brazos River Authority",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4600 Cobbs Dr, Waco, TX 76710, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-af47-70f0-bd0e-2ca61b114ef2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-af47-70f0-bd0e-2ca61b114ef2",
        "storage_key": "property/6767906449167035/019cfb50-af47-70f0-bd0e-2ca61b114ef2.webp",
        "width": 1280,
        "height": 912
      },
      "poi_business_url": "http://brazos.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8815088014222255767&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brazos-river-authority",
      "poi_latitude": "31.5448822",
      "poi_longitude": "-97.1919947",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 254-761-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff2-700a-9735-576e18aca7c7",
        "storage_key": "property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpQenhG2ET4YRl2aFN9h7VXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b5da14c9-ee7d-48b2-8411-bf3755c7829f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "La Puerta Waco",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Clay Ave, Waco, TX 76706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-ae37-708c-b42c-1ad7e7afba95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ae37-708c-b42c-1ad7e7afba95",
        "storage_key": "property/6767906449167035/019cfb50-ae37-708c-b42c-1ad7e7afba95.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.lapuertawaco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12772518668909505718&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-puerta-waco",
      "poi_latitude": "31.5526836",
      "poi_longitude": "-97.127919",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-301-4062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff2-700a-9735-576e18aca7c7",
        "storage_key": "property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqZd-qk-CT4YRtmxlww4aQbE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_de47531c-f373-4f2e-9b2c-049735b8c540",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Dealers Electrical Supply Co",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2320 Columbus Ave, Waco, TX 76701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-ae8e-74ce-9fbb-be407236c027.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-ae8e-74ce-9fbb-be407236c027",
        "storage_key": "property/6767906449167035/019cfb50-ae8e-74ce-9fbb-be407236c027.webp",
        "width": 794,
        "height": 470
      },
      "poi_business_url": "https://www.dealerselectrical.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12394278888850992905&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dealers-electrical-supply-co",
      "poi_latitude": "31.5429904",
      "poi_longitude": "-97.15069640000002",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 254-756-7251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff2-700a-9735-576e18aca7c7",
        "storage_key": "property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhchbmLiDT4YRCS8WUftSAaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7085d2c4-69c3-4c2a-be95-00ccf5858448",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Cornerstone Caregiving - Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2612 Washington Ave, Waco, TX 76710, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-af13-726a-9c4d-09c3a359ee80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb50-af13-726a-9c4d-09c3a359ee80",
        "storage_key": "property/6767906449167035/019cfb50-af13-726a-9c4d-09c3a359ee80.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://cornerstonecaregiving.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6258200559351579776&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cornerstone-caregiving---corporate-office",
      "poi_latitude": "31.53991959999999",
      "poi_longitude": "-97.1524871",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-410-2570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff2-700a-9735-576e18aca7c7",
        "storage_key": "property/6767906449167035/019cfb50-7ff2-700a-9735-576e18aca7c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz5h4HZODT4YRgERNWUCY2VY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_982ff3db-7bd3-4d25-bb00-f251cacb7f3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Robinson Primary School",
      "poi_type": "Education",
      "poi_address": "541 N Old Robinson Rd, Robinson, TX 76706, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.risdweb.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11021316892930854234&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "robinson-primary-school",
      "poi_latitude": "31.4772659",
      "poi_longitude": "-97.1233965",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 254-662-0251",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fe8-7219-bf94-8a16dd8d5462",
        "storage_key": "property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhazNwLKBT4YRWs0nGFKV85g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_370c216d-42d8-487e-bd0d-812dc7d21d6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Alta Vista Elementary School",
      "poi_type": "Education",
      "poi_address": "3637 Alta Vista Dr, Waco, TX 76706, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://altavista.wacoisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=623331519099551018&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "alta-vista-elementary-school",
      "poi_latitude": "31.5120879",
      "poi_longitude": "-97.1366941",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 254-662-3050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fe8-7219-bf94-8a16dd8d5462",
        "storage_key": "property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJt_UJhXiBT4YRKr07zbaEpgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e937c368-1490-41c7-a129-75bab97a2c22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Robinson Elementary School",
      "poi_type": "Education",
      "poi_address": "151 Peplow Dr, Robinson, TX 76706, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.risdweb.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14888997229351387919&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "robinson-elementary-school",
      "poi_latitude": "31.4798351",
      "poi_longitude": "-97.1225325",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-662-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fe8-7219-bf94-8a16dd8d5462",
        "storage_key": "property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGbOnTLKBT4YRD8NDRRhYoM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3b4b7db2-998f-4beb-8819-b567efbbe83a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Cesar Chavez Middle School",
      "poi_type": "Education",
      "poi_address": "700 S 15th St, Waco, TX 76706, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ccm.wacoisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17969608349716536522&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cesar-chavez-middle-school",
      "poi_latitude": "31.5434423",
      "poi_longitude": "-97.1334603",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 254-750-3736",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fe8-7219-bf94-8a16dd8d5462",
        "storage_key": "property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJRzKi0qCT4YRyly_RZbfYPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5586a5fa-313e-4d1c-b997-877e1c552617",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "University High School",
      "poi_type": "Education",
      "poi_address": "3201 S New Rd, Waco, TX 76706, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019d7917-22a7-71b5-950f-83a4781de89c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-22a7-71b5-950f-83a4781de89c",
        "storage_key": "property/6767906449167035/019d7917-22a7-71b5-950f-83a4781de89c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://uhs.wacoisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10934907421617744354&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "university-high-school",
      "poi_latitude": "31.5045719",
      "poi_longitude": "-97.1364817",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 254-756-1843",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fe8-7219-bf94-8a16dd8d5462",
        "storage_key": "property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0Ve0WSuCT4YR4ulORV2YwJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_9fe4c901-2ef2-4c47-a4f7-0ce4dd250946",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Waco High School",
      "poi_type": "Education",
      "poi_address": "GRR7+JQ, 2020 N 42nd St, Waco, TX 76710, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019d7917-20bd-7009-b9e4-f6c12afa2041.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-20bd-7009-b9e4-f6c12afa2041",
        "storage_key": "property/6767906449167035/019d7917-20bd-7009-b9e4-f6c12afa2041.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://whs.wacoisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10394912467264859738&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "waco-high-school",
      "poi_latitude": "31.5428737",
      "poi_longitude": "-97.1846287",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 254-776-1150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fe8-7219-bf94-8a16dd8d5462",
        "storage_key": "property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ69CBj3OET4YRWu6ZetAlQpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_3daf9bb6-14c6-4d5b-a1a1-bc3318088256",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Live Oak Classical Charter School",
      "poi_type": "Education",
      "poi_address": "420 S 5th St, Waco, TX 76706, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019d7917-222b-74c9-a592-8bbe421658e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-222b-74c9-a592-8bbe421658e8",
        "storage_key": "property/6767906449167035/019d7917-222b-74c9-a592-8bbe421658e8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://liveoakclassical.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13891735161552446815&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "live-oak-classical-charter-school",
      "poi_latitude": "31.5541078",
      "poi_longitude": "-97.1284631",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 254-714-1008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fe8-7219-bf94-8a16dd8d5462",
        "storage_key": "property/6767906449167035/019cfb50-7fe8-7219-bf94-8a16dd8d5462.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcT2_Nk6CT4YRXyUjIodbycA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_c5f8753a-4fef-47f5-842f-82b8dd936095",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Dave's Hot Chicken",
      "poi_type": "Restaurants",
      "poi_address": "4017 Jack Kultgen Fwy, Waco, TX 76706, USA",
      "poi_short_description": "Relaxed, colorful eatery serving chicken tenders and sandwiches with varying spice levels, plus fries and sides.",
      "poi_long_description": "People say this chicken restaurant serves delicious chicken sandwiches, sliders, and tenders. They also highlight the flavorful spices, crispy and juicy chicken, and the combination of pickles and sauce.\n\nOther reviews mention the wait can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019d7917-21e5-7524-be97-0359f03162c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-21e5-7524-be97-0359f03162c6",
        "storage_key": "property/6767906449167035/019d7917-21e5-7524-be97-0359f03162c6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://restaurants.daveshotchicken.com/tx/waco/best-hot-chicken-sandwich-on-jack-kultgen-fwy/?utm_campaign=google_maps&utm_medium=organic&utm_source=google&utm_content=website&utm_keyword=1100",
      "poi_directions_map_url": "https://maps.google.com/?cid=3412861589969195137&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dave-s-hot-chicken",
      "poi_latitude": "31.5095836",
      "poi_longitude": "-97.1434222",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 254-301-0198",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fde-745b-a437-085c381137ba",
        "storage_key": "property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx4yhCgKBT4YRgVCwsYjrXC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_3f87dbde-57e1-44b7-8fa4-39ec816d21a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Taqueria La Milpa",
      "poi_type": "Restaurants",
      "poi_address": "2011 La Salle Ave, Waco, TX 76706, USA",
      "poi_short_description": "Laid-back eatery, also a taco truck and stand known for Mexican eats, including barbacoa.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos, burritos, and tortas, with generous portions of meat and fresh ingredients. They highlight the authentic, homemade taste, and the good value for the price. They also like the casual, family-run vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019d7917-31d2-773f-8522-a03722de8f34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-31d2-773f-8522-a03722de8f34",
        "storage_key": "property/6767906449167035/019d7917-31d2-773f-8522-a03722de8f34.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4896443168437231816&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "taqueria-la-milpa",
      "poi_latitude": "31.5284334",
      "poi_longitude": "-97.1273143",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-717-6809",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fde-745b-a437-085c381137ba",
        "storage_key": "property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFzFhFC-CT4YRyOCWhR6p80M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f1e8e375-4a84-40ed-b50c-00a9536807c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Chuy's",
      "poi_type": "Restaurants",
      "poi_address": "5501 Legend Lake Pkwy, Waco, TX 76712, USA",
      "poi_short_description": "Chain serving \"big as yo' face\" burritos & other Tex-Mex dishes in kitschy, eclectic settings.",
      "poi_long_description": "People say this Tex-Mex restaurant serves flavorful fajitas, cheese enchiladas, and Chuy-Changas. They also highlight the fun atmosphere, affordable prices, and great margaritas.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019d7917-2ef3-77e9-b937-f9d77b9c2f7e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2ef3-77e9-b937-f9d77b9c2f7e",
        "storage_key": "property/6767906449167035/019d7917-2ef3-77e9-b937-f9d77b9c2f7e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chuys.com/locations/tx/waco/waco-tx/6016?cmpid=br:chy_ag:ie_ch:loc_ca:CHYGMB_sn:gmb_gt:waco-tx-6016_pl:locurl_rd:1015",
      "poi_directions_map_url": "https://maps.google.com/?cid=16889027093936889792&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chuy-s",
      "poi_latitude": "31.495272",
      "poi_longitude": "-97.159275",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-420-4242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fde-745b-a437-085c381137ba",
        "storage_key": "property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM9gvrD-BT4YRwF8O-KjgYeo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_10f0dd9c-1ede-465d-96d7-e3c779d5d154",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Saltgrass Steak House",
      "poi_type": "Restaurants",
      "poi_address": "5600 Legend Lake Pkwy, Waco, TX 76712, USA",
      "poi_short_description": "Informal Texas-themed chain offers a meaty menu & full bar amid cattle kitsch decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, appetizers, and drinks. They also highlight the attentive service, pleasant atmosphere, and reasonable prices.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019d7917-2eee-7120-a053-33408914076b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2eee-7120-a053-33408914076b",
        "storage_key": "property/6767906449167035/019d7917-2eee-7120-a053-33408914076b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saltgrass.com/location/saltgrass-waco/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2937733678232875818&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "saltgrass-steak-house",
      "poi_latitude": "31.4936305",
      "poi_longitude": "-97.1594359",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 254-420-0067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fde-745b-a437-085c381137ba",
        "storage_key": "property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ3-htj-BT4YRKrPFLzftxCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_ad75c0a0-84ab-468a-8c1d-106794d3d87c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Tejun The Texas Cajun- Robinson",
      "poi_type": "Restaurants",
      "poi_address": "711 Robinson Dr, Robinson, TX 76706, USA",
      "poi_short_description": "Informal quick-serve stop for Cajun-spiced seafood such as shrimp, lobster & crawfish.",
      "poi_long_description": "People say this seafood restaurant serves delicious crawfish, shrimp, and crab legs, as well as fried fish, alligator, and chicken strips. They highlight the reasonable prices, generous portions, and the fun, casual atmosphere with outdoor seating and a pond where kids can feed fish and turtles. They also like the friendly and prompt service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019d7917-2ece-75aa-b83d-8288c57d83f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-2ece-75aa-b83d-8288c57d83f9",
        "storage_key": "property/6767906449167035/019d7917-2ece-75aa-b83d-8288c57d83f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tejunthetexascajun.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2549948896234617363&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tejun-the-texas-cajun-robinson",
      "poi_latitude": "31.4917837",
      "poi_longitude": "-97.1219469",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 254-235-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fde-745b-a437-085c381137ba",
        "storage_key": "property/6767906449167035/019cfb50-7fde-745b-a437-085c381137ba.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDxeZkWSvSIYRE7p2ywI9YyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_e80073fd-8621-4478-ac3a-9ec63e4f695a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Waco Custom Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "425 Lake Air Dr, Waco, TX 76710, USA",
      "poi_short_description": "Locally owned store offering meat, seafood, and produce, plus a deli and bakery.",
      "poi_long_description": "Shoppers say this grocery store offers a great selection of fresh meats, cheeses, and kolaches, with many praising the bakery and butcher department. They also highlight the friendly and helpful staff, and appreciate the reasonable prices for high-quality goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019d7917-39cb-7070-8d7b-fae27d3bb157.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-39cb-7070-8d7b-fae27d3bb157",
        "storage_key": "property/6767906449167035/019d7917-39cb-7070-8d7b-fae27d3bb157.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://wacocustommarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1507760455512873473&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "waco-custom-marketplace",
      "poi_latitude": "31.5239442",
      "poi_longitude": "-97.1842668",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 254-227-6595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fed-7278-88a3-bfe48bf9b02a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fed-7278-88a3-bfe48bf9b02a",
        "storage_key": "property/6767906449167035/019cfb50-7fed-7278-88a3-bfe48bf9b02a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TMqqgaET4YRAdo5VSWk7BQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_bea3791f-46aa-4e14-a8e9-46244b854dce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Central Texas Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "2400 W Loop 340, Waco, TX 76711, USA",
      "poi_short_description": "Shopping center featuring specialty shops and eateries, plus parking.",
      "poi_long_description": "People say this shopping center offers a wide selection of stores, including clothing, outdoor goods, and restaurants. They highlight the convenient location near hotels and Baylor University, and the ample parking. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019d7917-396f-7436-9e91-c231020f9be5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-396f-7436-9e91-c231020f9be5",
        "storage_key": "property/6767906449167035/019d7917-396f-7436-9e91-c231020f9be5.webp",
        "width": 1280,
        "height": 337
      },
      "poi_business_url": "https://amzn.to/3HKyLbO",
      "poi_directions_map_url": "https://maps.google.com/?cid=10038514282824941598&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "central-texas-marketplace",
      "poi_latitude": "31.4974622",
      "poi_longitude": "-97.1568051",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-265-5255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff9-7309-a862-4dfeb905a566.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff9-7309-a862-4dfeb905a566",
        "storage_key": "property/6767906449167035/019cfb50-7ff9-7309-a862-4dfeb905a566.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJm8_xx2qBT4YRHkB3zI33T4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4111bbe5-5e77-4aa0-ac4e-724a5956124d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Brazos Place Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "Waco, TX 76710, USA",
      "poi_short_description": "Shopping mall with a variety of stores, including a bookstore and restaurants.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019d7917-437d-7575-94e9-31f7ed023e69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-437d-7575-94e9-31f7ed023e69",
        "storage_key": "property/6767906449167035/019d7917-437d-7575-94e9-31f7ed023e69.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18140347742399636521&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "brazos-place-shopping-center",
      "poi_latitude": "31.5268041",
      "poi_longitude": "-97.1704589",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff9-7309-a862-4dfeb905a566.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff9-7309-a862-4dfeb905a566",
        "storage_key": "property/6767906449167035/019cfb50-7ff9-7309-a862-4dfeb905a566.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI6JHkIuDT4YRKSTK9yh2v_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ffc9d6b0-7bc4-492e-acc9-a2b67a620479",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "AMC Galaxy 16",
      "poi_type": "Entertainment",
      "poi_address": "333 S Valley Mills Dr, Waco, TX 76710, USA",
      "poi_short_description": "Standard movie theater featuring discount tickets for new releases as well as concession specials.",
      "poi_long_description": "People say this movie theater offers good popcorn, soda, and candy. They also highlight the friendly staff and clean facilities.\n\nOther reviews mention the seats can be uncomfortable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019d7917-3eba-736a-ad42-0351f0c44cde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-3eba-736a-ad42-0351f0c44cde",
        "storage_key": "property/6767906449167035/019d7917-3eba-736a-ad42-0351f0c44cde.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/waco/amc-galaxy-16?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5191162069705480395&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amc-galaxy-16",
      "poi_latitude": "31.5248072",
      "poi_longitude": "-97.1596367",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 254-776-5010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7fe3-7503-8e95-21ffd1f47d5a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7fe3-7503-8e95-21ffd1f47d5a",
        "storage_key": "property/6767906449167035/019cfb50-7fe3-7503-8e95-21ffd1f47d5a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJvbs8leajRYYRy9hGAGa2Ckg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_4a23882b-1fe5-4c91-ab08-01b81b6945f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Waco Mammoth National Monument",
      "poi_type": "Entertainment",
      "poi_address": "6220 Steinbeck Bend Dr, Waco, TX 76708, USA",
      "poi_short_description": "Paleontological site featuring in-situ fossils of a herd of Ice Age mammoths & other animals.",
      "poi_long_description": "People say this science museum offers a unique opportunity to see real mammoth bones in situ and learn about paleontology. They highlight the affordable entry fee, the educational guided tours, and the cool, active dig site. They also like the knowledgeable and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019d7917-48ae-7288-9cf7-eabbd71856a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7917-48ae-7288-9cf7-eabbd71856a0",
        "storage_key": "property/6767906449167035/019d7917-48ae-7288-9cf7-eabbd71856a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nps.gov/waco/index.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=13872704300233162338&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "waco-mammoth-national-monument",
      "poi_latitude": "31.6067336",
      "poi_longitude": "-97.1758392",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 254-750-7946",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb50-7ff9-7309-a862-51dd3435b2b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb50-7ff9-7309-a862-51dd3435b2b2",
        "storage_key": "property/6767906449167035/019cfb50-7ff9-7309-a862-51dd3435b2b2.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJM0zoOlWDT4YRYn5ucQ-_hcA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6eaabb0b-0a68-483d-92b4-3a2513a4c134",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Harmony School of Innovation (6-12)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "harmony-school-of-innovation-6-12",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_91198cb0-94f3-4b1e-a3d3-9f4fb4b53da6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "poi_name": "Cabela’s",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "cabela-s",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_c9368e4adf16ded84fff06f7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_dbd1295dc7f3f9159b2bd0a5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_66e1a2de26e5a5757e80ed06",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a51a41565906808bf65a5e28",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_93059d159f0171c65da2670b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_5c04c07190bbbf42c9647e86",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_0bbb31ea-17c8-4182-9b5c-908c96066fe7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "rating": "5.0",
      "name": "Whitley Lowry",
      "text": "I absolutely love living here and I’m sad my lease is coming to end , but I have to move because my family is growing. We had such a great time here with management and neighbors. The dog park shared fun times and the pool was relaxing with fun times around neighbors and friends. The office provides great snacks and delicious coffee in the mornings to help get a good start on the day ! I’d recommend to live here to anyone !",
      "date": "2026-01-09",
      "title": ""
    },
    {
      "id": "custom_a0e05ff4-55b9-47a1-a984-01d87f714d57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "rating": "5.0",
      "name": "Syd J",
      "text": "super sweet and helpful office staff. maintenance is fast and easy to work with. would love it even more if they had wood floors but other than that the apartment itself is very nice and space. not overpriced for what they have to offer unlike most complexes now.",
      "date": "2026-01-09",
      "title": ""
    },
    {
      "id": "custom_2318c36d-5217-46b7-a90b-94eb1d0f4a03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "rating": "5.0",
      "name": "Klover Gandy",
      "text": "Michaela was an absolute doll, I came in pretty close to closing time this passed Saturday, and she still treated me amazingly. Didn’t rush me, wasn’t short with me, she had every right to be because she’s about to be off of work! But omg the units are beautiful, she answered all my questions and gave me a full tour, thoroughly enjoyed myself. Having her at the front is a no brainer and I would definitely consider giving her a raise due to the fact that she’s so good at her job! I hope to be a resident here soon 🤞",
      "date": "2026-01-13",
      "title": ""
    },
    {
      "id": "custom_9fbdcbb9-5233-405e-adaf-e9805351db6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "rating": "5.0",
      "name": "Danielle Allen",
      "text": "They did a good job at fixing my dishwasher however it was a little frustrating how long it took them to even start my request and then I had to call every week or so to see what was going on. I was having to reach out to follow up. It would’ve been nice if someone could’ve reached out to me to say hey this is what’s going on, etc. I understand that it takes a while for parts to come in, but the communication was lacking. I feel like if I wouldn’t have initiated any of the follow up calls, the dishwasher would probably still be non-working. But they did fix it once they got the part and I am happy with that, usually it’s a pretty quick turnaround time. Not sure why it was more delayed than usual?",
      "date": "2025-12-24",
      "title": ""
    },
    {
      "id": "custom_7b4b97ac-1cce-4453-bddd-b687f8d0e31a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "rating": "5.0",
      "name": "Nancy Salinas",
      "text": "The Bend has a very responsive team. They are polite and cooperative and take fast action whenever there is a concern. Clean, manicured lawns and quiet and respectful neighbors. If you have a pet, this is the place -- very pet friendly with responsible pet owners.",
      "date": "2026-01-15",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_1b0afd05-38da-4d74-aeec-92e4f148ec4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167035/019cfb51-0df9-708b-8937-6f54bbddbb28.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of a modern apartment community lounge area with kitchen",
        "public_id": "019cfb51-0df9-708b-8937-6f54bbddbb28",
        "storage_key": "property/6767906449167035/019cfb51-0df9-708b-8937-6f54bbddbb28.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Bend at New Road Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f8518d31d480c5872712ed3"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79d-aa2c-7450-8fd7-5c6c40302ca5",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "bend-at-new-road",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035"
    },
    {
      "lead_collector_id": "019cf79d-aa9f-705b-ac45-2c9ae764f442",
      "lead_source": "LANDING_PAGE",
      "name": "bend-at-new-road",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-waco-tx-new-road",
      "search_query": "pet friendly apartments Waco TX",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Waco, TX",
      "h2_subtitle": "Discover a welcoming community at Bend at New Road. Our pet friendly apartments in Waco, TX are perfect for you and your furry companions.",
      "page_copy": "Experience a comfortable lifestyle at Bend at New Road, where you and your furry friends are always welcome. Located in the charming Alta Vista neighborhood, our pet friendly apartments in Waco, TX offer an array of amenities that cater to both you and your pets. Enjoy the tranquility of a private patio or balcony, perfect for relaxing with your pet after a long day. \n\nBeyond your doorstep, explore engaging community spaces like our clubhouse, where you can unwind and socialize while your companions enjoy the secure, spacious environment. With onsite management always ready to assist, Bend at New Road offers not just a home, but a pet-friendly community where you and your pets can thrive.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Waco, TX",
      "seo_description": "Find pet friendly apartments in Waco, TX at Bend at New Road. Enjoy a community that welcomes you and your furry friends with open arms.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-mclennan",
      "search_query": "apartments with a fitness center in McLennan County",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in McLennan",
      "h2_subtitle": "Stay active at Bend at New Road. Our apartments feature a fitness center, offering a convenient lifestyle in McLennan County.",
      "page_copy": "Bend at New Road invites you to experience a dynamic and active lifestyle in McLennan County. Our community provides top-notch apartments with a fitness center, tailored to meet your wellness needs. Conveniently situated in the beautiful Alta Vista neighborhood, our property ensures you have easy access to modern fitness facilities right at home.\n\nEnhance your daily routine with our fully-equipped fitness center and enjoy additional amenities like a relaxing community clubhouse with billiards and shuffleboard. Our commitment to a healthy and engaging environment makes Bend at New Road the ideal choice for those seeking apartments with a fitness center in McLennan County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in McLennan",
      "seo_description": "Discover apartments with a fitness center at Bend in McLennan County. Enjoy on-site fitness facilities and a vibrant community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "swimming-pool-apartments-alta-vista",
      "search_query": "apartments with swimming pools in Alta Vista",
      "category": "Amenity",
      "h1_title": "Apartments with Swimming Pools in Alta Vista",
      "h2_subtitle": "Dive into comfort at Bend at New Road. Our apartments in Alta Vista feature refreshing swimming pools for your enjoyment.",
      "page_copy": "Bend at New Road offers the ideal retreat for those seeking apartments with swimming pools in the charming Alta Vista neighborhood. Immerse yourself in the serene atmosphere of our community and make use of our inviting swimming pools, perfect for beating the Texas heat.\n\nOur community is designed with your leisure in mind, offering a range of amenities including a relaxing clubhouse with billiards and shuffleboard. At Bend at New Road, you can enjoy the best of both relaxation and recreation, making it the perfect choice for anyone looking for apartments with swimming pools in the desirable Alta Vista area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Swimming Pools in Alta Vista",
      "seo_description": "Find apartments with swimming pools at Bend in Alta Vista. Enjoy a refreshing lifestyle with pools and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-waco-tx-bend-new-road",
      "search_query": "dog friendly apartments Waco TX",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Waco, TX",
      "h2_subtitle": "Bend at New Road welcomes pets. Discover our dog friendly apartments in vibrant Waco, TX, with amenities you and your pet will love.",
      "page_copy": "At Bend at New Road, we understand that your dog is part of your family, which is why we proudly offer dog friendly apartments in the heart of Waco, TX. Nestled in the Alta Vista neighborhood, our community is designed to accommodate both you and your four-legged companions with a range of pet-friendly amenities.\n\nExplore our spacious grounds and relax in your private patio or balcony, an ideal spot for you and your dog to unwind. With onsite management and community features like a clubhouse equipped with billiards and shuffleboard, Bend at New Road is not just a home, but a thriving community perfect for dog lovers.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Waco, TX",
      "seo_description": "Discover dog friendly apartments in Waco, TX at Bend at New Road, offering amenities designed for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "modern-kitchens-apartments-near-I-35",
      "search_query": "apartments with modern kitchens near I-35",
      "category": "Amenity",
      "h1_title": "Apartments with Modern Kitchens near I-35",
      "h2_subtitle": "Experience contemporary living at Bend at New Road. Our apartments feature modern kitchens, conveniently located near I-35.",
      "page_copy": "Discover the perfect blend of style and convenience at Bend at New Road, where our apartments boast modern kitchens and easy access to I-35. Situated in the vibrant Alta Vista neighborhood of Waco, TX, our community is ideal for those who love cooking and entertaining in sleek, updated spaces.\n\nWith modern appliances including a dishwasher and microwave, our kitchens are designed for both functionality and aesthetics. Enjoy other amenities like a private patio or balcony, and a community clubhouse with billiards and shuffleboard. Bend at New Road provides the perfect setting for contemporary living, just a stone’s throw from I-35.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Modern Kitchens near I-35",
      "seo_description": "Explore Bend at New Road for apartments with modern kitchens near I-35. Enjoy stylish living with updated kitchens and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-waco-tx-bend-new-road",
      "search_query": "one bedroom apartments waco tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Waco, TX",
      "h2_subtitle": "Find the perfect one bedroom apartment at Bend at New Road. Located in Waco, TX, offering modern amenities and a vibrant community.",
      "page_copy": "At Bend at New Road, our one bedroom apartments in Waco, TX provide the ideal living space for comfort and convenience. Nestled in the charming Alta Vista neighborhood, these apartments are perfect for individuals or couples seeking a modern home with access to excellent amenities.\n\nEach one bedroom apartment comes equipped with a private patio or balcony and a modern kitchen complete with a dishwasher and microwave. Dive into a community offering secure package receiving and a clubhouse with billiards and shuffleboard. Choose Bend at New Road for a lively lifestyle and a welcoming environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Waco, TX",
      "seo_description": "Discover one bedroom apartments at Bend at New Road in Waco, TX. Enjoy modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "two-bedroom-floorplans-alta-vista-waco",
      "search_query": "two bedroom floorplans alta vista",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floorplans in Alta Vista",
      "h2_subtitle": "Explore spacious two bedroom floorplans at Bend at New Road. Nestled in the vibrant Alta Vista neighborhood, this is your ideal Waco living location.",
      "page_copy": "Bend at New Road offers a variety of spacious two bedroom floorplans that cater to your lifestyle needs, all located in the vibrant Alta Vista neighborhood of Waco, TX. Our thoughtfully designed layouts provide generous living spaces with modern amenities, making it the perfect choice for roommates or families.\n\nEach of our two bedroom apartments features a private patio or balcony, along with a fully-equipped kitchen that includes a dishwasher and microwave. Enjoy community perks like our relaxing clubhouse with billiards and shuffleboard. Experience elevated living at Bend at New Road, where comfort meets convenience in Alta Vista.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floorplans in Alta Vista",
      "seo_description": "Discover two bedroom floorplans at Bend at New Road in Alta Vista, Waco. Enjoy spacious layouts and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "apartments-near-baylor-university-waco",
      "search_query": "apartments near Baylor University Waco",
      "category": "School",
      "h1_title": "Apartments Near Baylor University, Waco",
      "h2_subtitle": "Discover convenient living at Bend at New Road. Perfectly situated near Baylor University, our apartments offer modern amenities in Waco, TX.",
      "page_copy": "Located just a short drive from Baylor University, Bend at New Road offers ideal apartments for students and faculty seeking a blend of comfort and convenience. Nestled in the vibrant Alta Vista neighborhood, our community provides quick access to campus and local attractions, making it a prime location for university affiliates.\n\nOur apartments feature modern kitchens with dishwashers and microwaves, alongside private patios or balconies for personal leisure. Residents can enjoy amenities such as secure package receiving and a community clubhouse with billiards and shuffleboard. Choose Bend at New Road for a vibrant living experience near Baylor University in Waco.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Baylor University, Waco",
      "seo_description": "Find modern apartments near Baylor University at Bend at New Road in Waco, TX. Offering comfort and convenience close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "bend-at-new-road-near-mclennan-community-college",
      "search_query": "Bend at New Road close to McLennan Community College",
      "category": "School",
      "h1_title": "Bend at New Road Near McLennan Community College",
      "h2_subtitle": "Discover convenient living at Bend at New Road, ideally located near McLennan Community College in Waco, TX. Enjoy modern amenities and a vibrant community.",
      "page_copy": "Bend at New Road is the perfect place for students and staff of McLennan Community College seeking the ideal blend of proximity and comfort. Situated in the scenic Alta Vista neighborhood, our community offers an easy commute to campus, making your daily travel hassle-free.\n\nOur modern apartments feature amenities such as a private patio or balcony and a fully equipped kitchen with a dishwasher and microwave. Enjoy community features like secure package receiving and a clubhouse complete with billiards and shuffleboard. Experience the convenience of living near McLennan Community College at Bend at New Road.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Bend at New Road Near McLennan Community College",
      "seo_description": "Live near McLennan Community College at Bend at New Road in Waco, TX. Enjoy modern amenities and a short commute to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "alta-vista-apartments-hankamer-business-school",
      "search_query": "Alta Vista apartments by Hankamer School of Business",
      "category": "School",
      "h1_title": "Alta Vista Apartments by Hankamer School",
      "h2_subtitle": "Explore Bend at New Road, offering premier apartments near Hankamer School of Business. Experience vibrant living in Alta Vista, Waco.",
      "page_copy": "Situated in the bustling Alta Vista neighborhood, Bend at New Road offers the ideal apartment living experience for students and faculty of the Hankamer School of Business. Enjoy the convenience of a short commute, allowing you more time to focus on your studies or work.\n\nOur community features modern living spaces with amenities including private patios or balconies and fully-equipped kitchens with dishwashers and microwaves. Residents can take advantage of on-site management and community perks like a clubhouse with billiards and shuffleboard. Choose Bend at New Road for a well-rounded lifestyle near the Hankamer School of Business in Waco.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Alta Vista Apartments by Hankamer School",
      "seo_description": "Discover apartments near Hankamer School of Business at Bend at New Road in Alta Vista. Enjoy modern amenities and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "apartments-near-baylor-scott-and-white-hillcrest",
      "search_query": "apartments near Baylor Scott & White Medical Center Hillcrest Waco",
      "category": "Hospital",
      "h1_title": "Apartments Near Baylor Scott & White Hillcrest",
      "h2_subtitle": "Live at Bend at New Road, conveniently located near Baylor Scott & White Medical Center Hillcrest. Experience the best of Waco living.",
      "page_copy": "Bend at New Road presents an ideal living choice for professionals and students affiliated with Baylor Scott & White Medical Center Hillcrest. Located in the welcoming Alta Vista neighborhood, our community ensures you are never far from your workplace or study center, making daily commutes a breeze.\n\nOur apartments offer desirable features including private patios or balconies and kitchens fitted with modern conveniences like dishwashers and microwaves. Residents can also enjoy community amenities such as secure package receiving and a clubhouse with billiards. Make Bend at New Road your home and enjoy a convenient lifestyle near Baylor Scott & White Hillcrest in Waco, TX.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Baylor Scott & White Hillcrest",
      "seo_description": "Find apartments near Baylor Scott & White Hillcrest at Bend at New Road in Waco, TX. Experience modern living and convenient proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "apartments-near-ascension-providence-hospital",
      "search_query": "apartments close to Ascension Providence Hospital McLennan County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Ascension Providence",
      "h2_subtitle": "Discover Bend at New Road, ideally situated near Ascension Providence Hospital in McLennan County. Enjoy a convenient and modern lifestyle.",
      "page_copy": "Bend at New Road is perfectly positioned for those seeking convenient living near Ascension Providence Hospital. Located in the vibrant Alta Vista neighborhood of McLennan County, our community provides easy access to healthcare professionals and patients alike.\n\nOur well-appointed apartments feature essentials like private patios or balconies and kitchens complete with dishwashers and microwaves. Residents can also take advantage of on-site management and community amenities such as a relaxing clubhouse with billiards. Live at Bend at New Road, where you can enjoy the comfort of being close to Ascension Providence Hospital while indulging in a modern lifestyle in Waco, TX.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Ascension Providence",
      "seo_description": "Find modern apartments near Ascension Providence Hospital at Bend at New Road. Enjoy a convenient location and quality living in McLennan County, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "apartments-near-cameron-park-waco",
      "search_query": "apartments near Cameron Park Waco",
      "category": "Park",
      "h1_title": "Apartments Near Cameron Park, Waco",
      "h2_subtitle": "Enjoy living near Waco's scenic gem, Cameron Park, at Bend at New Road. Discover a blend of nature and modern convenience.",
      "page_copy": "Experience the perfect blend of nature and city living at Bend at New Road, ideally located near Waco's renowned Cameron Park. Our community offers easy access for those who relish outdoor adventures and tranquil views right at their doorstep.\n\nApartments at Bend at New Road feature private patios or balconies and kitchens equipped with modern conveniences like dishwashers and microwaves. The community also boasts a relaxing clubhouse with billiards, perfect for unwinding. Choose Bend at New Road to enjoy proximity to Cameron Park, where adventure meets relaxation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Cameron Park, Waco",
      "seo_description": "Discover Bend at New Road, offering quality apartments near Cameron Park in Waco. Enjoy modern amenities and easy access to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "rentals-close-to-woodway-park-tx",
      "search_query": "rentals close to Woodway Park TX",
      "category": "Park",
      "h1_title": "Rentals Close to Woodway Park, TX",
      "h2_subtitle": "Explore Bend at New Road, located conveniently near Woodway Park. Enjoy access to both recreation and modern amenities.",
      "page_copy": "Bend at New Road provides an excellent rental option for those desiring proximity to the natural beauty of Woodway Park, TX. Our community offers easy access to recreational spaces, allowing residents to enjoy the serene environment and outdoor activities.\n\nEach apartment features contemporary amenities such as private patios or balconies, and kitchens equipped with dishwashers and microwaves. Residents can also enjoy secure package receiving and a community clubhouse with shuffleboard. Choose Bend at New Road for a peaceful lifestyle close to Woodway Park, where nature and modern living converge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Close to Woodway Park, TX",
      "seo_description": "Find rentals near Woodway Park at Bend at New Road. Enjoy modern living and easy access to nature in a serene setting near Waco, TX.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "living-by-jacobs-ladder-alta-vista",
      "search_query": "living by Jacob's Ladder Alta Vista",
      "category": "Park",
      "h1_title": "Living by Jacob's Ladder, Alta Vista",
      "h2_subtitle": "Experience Bend at New Road, nestled close to the iconic Jacob's Ladder in Alta Vista. Embrace convenience and charm in Waco.",
      "page_copy": "Bend at New Road offers exceptional living right by the famed Jacob's Ladder in the charming Alta Vista neighborhood. Our community is perfect for those wanting to embrace a balanced lifestyle featuring both urban convenience and outdoor recreation.\n\nLiving here, you'll appreciate apartments that include private patios or balconies, and a modern kitchen setup with dishwashers and microwaves. Plus, residents enjoy the benefits of on-site management and a vibrant clubhouse with fun amenities like billiards. Choose Bend at New Road to live near Jacob's Ladder, where comfort meets adventure in the heart of Waco.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living by Jacob's Ladder, Alta Vista",
      "seo_description": "Discover Bend at New Road, offering comfortable living by Jacob's Ladder in Waco's Alta Vista. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167035",
      "source": "generator",
      "page_item_url": "apartment-homes-near-whitehall-park-mclennan-county",
      "search_query": "apartment homes near Whitehall Park McLennan County",
      "category": "Park",
      "h1_title": "Apartment Homes Near Whitehall Park",
      "h2_subtitle": "Discover Bend at New Road, offering modern apartment homes close to Whitehall Park in McLennan County. Enjoy nature and comfort.",
      "page_copy": "Located in scenic McLennan County, Bend at New Road offers residents beautiful apartment homes just a short distance from Whitehall Park. Our community provides a peaceful environment combined with easy park access, ideal for those who enjoy outdoor activities and relaxation.\n\nThese apartment homes include features like private patios or balconies, dishwashers, and microwaves, ensuring modern comfort. The community also boasts secure package receiving and a relaxing clubhouse with billiards. Choose Bend at New Road for a homely atmosphere near Whitehall Park, where lush greenery meets convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Near Whitehall Park",
      "seo_description": "Find apartment homes near Whitehall Park at Bend at New Road in McLennan County. Enjoy modern amenities and a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5148"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-V1B5WKR9ZC"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151477"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/the-bend-at-new-road/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-ND8MVKZB"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449167035/019d1bd6-fda1-712d-8af3-b5dd959817b3.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "a67e8d24-1c11-4bf4-8de3-9f55d6c9b849"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "833-766-7521"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6504af6e207d98cf1011f5e3"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IitGNkNKRDYyY2RDdW11MmMvT2FMOWc9PSIsInZhbHVlIjoiZExMNGJrY1dCRElBUm9hZTIyTjNQQT09IiwibWFjIjoiNjI4MTJhNmRlYTMwMTI3MGY2ZmYxNTNjODk0ZDlkMGZmZTQ5MTZmYjI5MDI4NjUzODZiNWExMWVkNjU0NTdjNyJ9"
    }
  ],
  "custom_qb_id": "5148",
  "custom_ga4_id": "G-V1B5WKR9ZC",
  "custom_repli_id": "10041151477",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/the-bend-at-new-road/register/",
  "custom_google_gtm_id": "GTM-ND8MVKZB",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449167035/019d1bd6-fda1-712d-8af3-b5dd959817b3.pdf",
  "custom_rentgrata_property_id": "a67e8d24-1c11-4bf4-8de3-9f55d6c9b849",
  "custom_ppc_tracking_phone_number": "833-766-7521",
  "custom_residentboost_apartment_id": "6504af6e207d98cf1011f5e3",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IitGNkNKRDYyY2RDdW11MmMvT2FMOWc9PSIsInZhbHVlIjoiZExMNGJrY1dCRElBUm9hZTIyTjNQQT09IiwibWFjIjoiNjI4MTJhNmRlYTMwMTI3MGY2ZmYxNTNjODk0ZDlkMGZmZTQ5MTZmYjI5MDI4NjUzODZiNWExMWVkNjU0NTdjNyJ9"
};

export const generatedAt = '2026-08-27T21:33:35.512Z';
